import {emptySplitApi as api} from './emptyApi';
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        requeueJob: build.query<RequeueJobApiResponse, RequeueJobApiArg>({
            query: (queryArg) => ({
                url: `/api/Admin/RequeueJob`,
                params: {
                    queuedDataKey: queryArg.queuedDataKey,
                    process: queryArg.process,
                },
            }),
        }),
        getAppDefaults: build.query<
            GetAppDefaultsApiResponse,
            GetAppDefaultsApiArg
        >({
            query: () => ({url: `/api/Admin/AppDefault`}),
        }),
        putAppDefaults: build.mutation<
            PutAppDefaultsApiResponse,
            PutAppDefaultsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Admin/AppDefault/${queryArg.parmId}`,
                method: 'PUT',
                body: queryArg.appDefaultVm,
            }),
        }),
        getInvoicesApprovalPopulationData: build.query<
            GetInvoicesApprovalPopulationDataApiResponse,
            GetInvoicesApprovalPopulationDataApiArg
        >({
            query: () => ({url: `/api/ApproveInvoices`}),
        }),
        getInvoicesNeedingApproval: build.mutation<
            GetInvoicesNeedingApprovalApiResponse,
            GetInvoicesNeedingApprovalApiArg
        >({
            query: (queryArg) => ({
                url: `/api/ApproveInvoices/search`,
                method: 'POST',
                body: queryArg.invoiceApprovalOptionsVm,
            }),
        }),
        getMinimalInvoiceDetail: build.query<
            GetMinimalInvoiceDetailApiResponse,
            GetMinimalInvoiceDetailApiArg
        >({
            query: (queryArg) => ({
                url: `/api/ApproveInvoices/invoicedetail/${queryArg.id}`,
            }),
        }),
        approveInvoices: build.mutation<
            ApproveInvoicesApiResponse,
            ApproveInvoicesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/ApproveInvoices/approve`,
                method: 'POST',
                body: queryArg.approveInvoicesRequestVm,
            }),
        }),
        saveCurrentInvoiceState: build.mutation<
            SaveCurrentInvoiceStateApiResponse,
            SaveCurrentInvoiceStateApiArg
        >({
            query: (queryArg) => ({
                url: `/api/ApproveInvoices/save`,
                method: 'POST',
                body: queryArg.approveInvoicesRequestVm,
            }),
        }),
        postApiApproveInvoicesFromInvoiceIdxs: build.mutation<
            PostApiApproveInvoicesFromInvoiceIdxsApiResponse,
            PostApiApproveInvoicesFromInvoiceIdxsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/ApproveInvoices/fromInvoiceIdxs`,
                method: 'POST',
                body: queryArg.body,
            }),
        }),
        getAllAscChargeCodes: build.query<
            GetAllAscChargeCodesApiResponse,
            GetAllAscChargeCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/AscChargeCode`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        createAscChargeCodes: build.mutation<
            CreateAscChargeCodesApiResponse,
            CreateAscChargeCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/AscChargeCode`,
                method: 'POST',
                body: queryArg.ascChargeCodeVm,
            }),
        }),
        modifyAscChargeCodes: build.mutation<
            ModifyAscChargeCodesApiResponse,
            ModifyAscChargeCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/AscChargeCode/${queryArg.codeId}`,
                method: 'PUT',
                body: queryArg.ascChargeCodeVm,
            }),
        }),
        deleteAscChargeCodes: build.mutation<
            DeleteAscChargeCodesApiResponse,
            DeleteAscChargeCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/AscChargeCode/${queryArg.codeId}`,
                method: 'DELETE',
            }),
        }),
        getInvoiceChargeTypes: build.query<
            GetInvoiceChargeTypesApiResponse,
            GetInvoiceChargeTypesApiArg
        >({
            query: () => ({url: `/api/AscChargeCode/ChargeTypes`}),
        }),
        getAllAscRefCodes: build.query<
            GetAllAscRefCodesApiResponse,
            GetAllAscRefCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/AscRefCode`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        createAscRefCodes: build.mutation<
            CreateAscRefCodesApiResponse,
            CreateAscRefCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/AscRefCode`,
                method: 'POST',
                body: queryArg.ascReferenceCodeVm,
            }),
        }),
        modifyAscRefCodes: build.mutation<
            ModifyAscRefCodesApiResponse,
            ModifyAscRefCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/AscRefCode/${queryArg.codeId}`,
                method: 'PUT',
                body: queryArg.ascReferenceCodeVm,
            }),
        }),
        deleteAscRefCodes: build.mutation<
            DeleteAscRefCodesApiResponse,
            DeleteAscRefCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/AscRefCode/${queryArg.codeId}`,
                method: 'DELETE',
            }),
        }),
        getGenMiles: build.mutation<GetGenMilesApiResponse, GetGenMilesApiArg>({
            query: (queryArg) => ({
                url: `/api/Audit/AuditMiles`,
                method: 'POST',
                body: queryArg.auditMilesRequestVm,
            }),
        }),
        login: build.mutation<LoginApiResponse, LoginApiArg>({
            query: (queryArg) => ({
                url: `/api/Authentication`,
                method: 'POST',
                body: queryArg.loginVm,
            }),
        }),
        refreshToken: build.query<RefreshTokenApiResponse, RefreshTokenApiArg>({
            query: () => ({url: `/api/Authentication`}),
        }),
        loginWithPermissions: build.mutation<
            LoginWithPermissionsApiResponse,
            LoginWithPermissionsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Authentication/withpermissions`,
                method: 'POST',
                body: queryArg.loginVm,
            }),
        }),
        refreshWithPermissions: build.query<
            RefreshWithPermissionsApiResponse,
            RefreshWithPermissionsApiArg
        >({
            query: () => ({url: `/api/Authentication/withpermissions`}),
        }),
        logOut: build.query<LogOutApiResponse, LogOutApiArg>({
            query: () => ({url: `/api/Authentication/logout`}),
        }),
        getMyUser: build.query<GetMyUserApiResponse, GetMyUserApiArg>({
            query: () => ({url: `/api/Authentication/getmyuser`}),
        }),
        getAllBankAccounts: build.query<
            GetAllBankAccountsApiResponse,
            GetAllBankAccountsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/BankAccount`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        getBillToById: build.query<
            GetBillToByIdApiResponse,
            GetBillToByIdApiArg
        >({
            query: (queryArg) => ({url: `/api/BillTo/${queryArg.id}`}),
        }),
        getDataEntryAscRefCodes: build.query<
            GetDataEntryAscRefCodesApiResponse,
            GetDataEntryAscRefCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/BillTo/${queryArg.id}/DataEntryAscRefCodes/${queryArg.carrierId}`,
            }),
        }),
        getAllBillTo: build.query<GetAllBillToApiResponse, GetAllBillToApiArg>({
            query: () => ({url: `/api/BillTo`}),
        }),
        getBillToForDisplay: build.query<
            GetBillToForDisplayApiResponse,
            GetBillToForDisplayApiArg
        >({
            query: () => ({url: `/api/BillTo/dropdown`}),
        }),
        getCustomerById: build.query<
            GetCustomerByIdApiResponse,
            GetCustomerByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/BillTo/Admin/${queryArg.customerId}`,
            }),
        }),
        modifyCustomers: build.mutation<
            ModifyCustomersApiResponse,
            ModifyCustomersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/BillTo/Admin/${queryArg.customerId}`,
                method: 'PUT',
                body: queryArg.billToVm,
            }),
        }),
        deleteCustomers: build.mutation<
            DeleteCustomersApiResponse,
            DeleteCustomersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/BillTo/Admin/${queryArg.customerId}`,
                method: 'DELETE',
            }),
        }),
        getAllCustomers: build.query<
            GetAllCustomersApiResponse,
            GetAllCustomersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/BillTo/Admin`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        createCustomers: build.mutation<
            CreateCustomersApiResponse,
            CreateCustomersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/BillTo/Admin`,
                method: 'POST',
                body: queryArg.billToVm,
            }),
        }),
        getParentCustomers: build.query<
            GetParentCustomersApiResponse,
            GetParentCustomersApiArg
        >({
            query: () => ({url: `/api/BillTo/Parent`}),
        }),
        activateCustomers: build.mutation<
            ActivateCustomersApiResponse,
            ActivateCustomersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/BillTo/Admin/${queryArg.customerId}/Active`,
                method: 'PUT',
                body: queryArg.billToActiveVm,
            }),
        }),
        getModeDefaultsByCustomer: build.query<
            GetModeDefaultsByCustomerApiResponse,
            GetModeDefaultsByCustomerApiArg
        >({
            query: (queryArg) => ({
                url: `/api/BillToModeDefault/${queryArg.customerId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        createBillToModeDefault: build.mutation<
            CreateBillToModeDefaultApiResponse,
            CreateBillToModeDefaultApiArg
        >({
            query: (queryArg) => ({
                url: `/api/BillToModeDefault`,
                method: 'POST',
                body: queryArg.billToModeDefaultVm,
            }),
        }),
        modifyBillToModeDefault: build.mutation<
            ModifyBillToModeDefaultApiResponse,
            ModifyBillToModeDefaultApiArg
        >({
            query: (queryArg) => ({
                url: `/api/BillToModeDefault/${queryArg.defaultId}`,
                method: 'PUT',
                body: queryArg.billToModeDefaultVm,
            }),
        }),
        deleteBillToModeDefault: build.mutation<
            DeleteBillToModeDefaultApiResponse,
            DeleteBillToModeDefaultApiArg
        >({
            query: (queryArg) => ({
                url: `/api/BillToModeDefault/${queryArg.defaultId}`,
                method: 'DELETE',
            }),
        }),
        getBillToMapsByCarrier: build.query<
            GetBillToMapsByCarrierApiResponse,
            GetBillToMapsByCarrierApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrBtMap/${queryArg.carrierId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        createCarrierBtMap: build.mutation<
            CreateCarrierBtMapApiResponse,
            CreateCarrierBtMapApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrBtMap`,
                method: 'POST',
                body: queryArg.carrBtMapVm,
            }),
        }),
        deleteCarrierBtMap: build.mutation<
            DeleteCarrierBtMapApiResponse,
            DeleteCarrierBtMapApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrBtMap/${queryArg.carrId}/${queryArg.carrAcct}/${queryArg.btId}`,
                method: 'DELETE',
            }),
        }),
        getCarrierEdiMasterById: build.query<
            GetCarrierEdiMasterByIdApiResponse,
            GetCarrierEdiMasterByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrEdiMaster/${queryArg.carrierId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        createCarrierEdiMaster: build.mutation<
            CreateCarrierEdiMasterApiResponse,
            CreateCarrierEdiMasterApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrEdiMaster`,
                method: 'POST',
                body: queryArg.carrEdiMasterVm,
            }),
        }),
        modifyCarrierEdiMaster: build.mutation<
            ModifyCarrierEdiMasterApiResponse,
            ModifyCarrierEdiMasterApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrEdiMaster/${queryArg.senderQual}/${queryArg.senderId}/${queryArg.ediType}/${queryArg.rcvQual}/${queryArg.rcvId}`,
                method: 'PUT',
                body: queryArg.carrEdiMasterVm,
            }),
        }),
        deleteCarrierEdiMaster: build.mutation<
            DeleteCarrierEdiMasterApiResponse,
            DeleteCarrierEdiMasterApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrEdiMaster/${queryArg.senderQual}/${queryArg.senderId}/${queryArg.ediType}/${queryArg.rcvQual}/${queryArg.rcvId}`,
                method: 'DELETE',
            }),
        }),
        getAllCarrierFamilies: build.query<
            GetAllCarrierFamiliesApiResponse,
            GetAllCarrierFamiliesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrFam`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        getCarriersForDropdown: build.query<
            GetCarriersForDropdownApiResponse,
            GetCarriersForDropdownApiArg
        >({
            query: () => ({url: `/api/Carrier`}),
        }),
        getByScac: build.query<GetByScacApiResponse, GetByScacApiArg>({
            query: (queryArg) => ({url: `/api/Carrier/scac/${queryArg.scac}`}),
        }),
        getCarrierChargeCodeMapping: build.query<
            GetCarrierChargeCodeMappingApiResponse,
            GetCarrierChargeCodeMappingApiArg
        >({
            query: () => ({url: `/api/Carrier/chargecodemapping`}),
        }),
        getCarrierChargeCodeMappingById: build.query<
            GetCarrierChargeCodeMappingByIdApiResponse,
            GetCarrierChargeCodeMappingByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Carrier/${queryArg.id}/chargecodemapping`,
            }),
        }),
        addNewCarrierChargeCodeMapping: build.mutation<
            AddNewCarrierChargeCodeMappingApiResponse,
            AddNewCarrierChargeCodeMappingApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Carrier/${queryArg.id}/chargecodemapping`,
                method: 'POST',
                body: queryArg.carrierChargeCodeMappingVm,
            }),
        }),
        updateCarrierChargeCodeMapping: build.mutation<
            UpdateCarrierChargeCodeMappingApiResponse,
            UpdateCarrierChargeCodeMappingApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Carrier/${queryArg.id}/chargecodemapping`,
                method: 'PUT',
                body: queryArg.carrierChargeCodeMappingVm,
            }),
        }),
        deletCarrierChargeCodeMapping: build.mutation<
            DeletCarrierChargeCodeMappingApiResponse,
            DeletCarrierChargeCodeMappingApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Carrier/${queryArg.id}/chargecodemapping`,
                method: 'DELETE',
                body: queryArg.carrierChargeCodeMappingVm,
            }),
        }),
        getCarrierChargeCodeMappingOverrides: build.query<
            GetCarrierChargeCodeMappingOverridesApiResponse,
            GetCarrierChargeCodeMappingOverridesApiArg
        >({
            query: () => ({url: `/api/Carrier/chargecodemappingoverrides`}),
        }),
        getCarrierChargeCodeMappingOverrideByCarrierId: build.query<
            GetCarrierChargeCodeMappingOverrideByCarrierIdApiResponse,
            GetCarrierChargeCodeMappingOverrideByCarrierIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Carrier/${queryArg.id}/chargecodemappingoverrides`,
            }),
        }),
        addNewCarrierChargeCodeMappingOverride: build.mutation<
            AddNewCarrierChargeCodeMappingOverrideApiResponse,
            AddNewCarrierChargeCodeMappingOverrideApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Carrier/${queryArg.id}/chargecodemappingoverrides/${queryArg.billto}`,
                method: 'POST',
                body: queryArg.carrierChargeCodesCustomerModeOverrideVm,
            }),
        }),
        updateCarrierChargeCodeMappingOverride: build.mutation<
            UpdateCarrierChargeCodeMappingOverrideApiResponse,
            UpdateCarrierChargeCodeMappingOverrideApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Carrier/${queryArg.id}/chargecodemappingoverrides/${queryArg.billto}`,
                method: 'PUT',
                body: queryArg.carrierChargeCodesCustomerModeOverrideVm,
            }),
        }),
        deleteCarrierChargeCodeMappingOverride: build.mutation<
            DeleteCarrierChargeCodeMappingOverrideApiResponse,
            DeleteCarrierChargeCodeMappingOverrideApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Carrier/${queryArg.id}/chargecodemappingoverrides/${queryArg.billto}`,
                method: 'DELETE',
                body: queryArg.carrierChargeCodesCustomerModeOverrideVm,
            }),
        }),
        getCarrierById: build.query<
            GetCarrierByIdApiResponse,
            GetCarrierByIdApiArg
        >({
            query: (queryArg) => ({url: `/api/Carrier/${queryArg.carrierId}`}),
        }),
        getAllCarriers: build.query<
            GetAllCarriersApiResponse,
            GetAllCarriersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Carrier/Admin`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        createCarriers: build.mutation<
            CreateCarriersApiResponse,
            CreateCarriersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Carrier/Admin`,
                method: 'POST',
                body: queryArg.carrierVm,
            }),
        }),
        modifyCarriers: build.mutation<
            ModifyCarriersApiResponse,
            ModifyCarriersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Carrier/Admin/${queryArg.carrierId}`,
                method: 'PUT',
                body: queryArg.carrierVm,
            }),
        }),
        deleteCarriers: build.mutation<
            DeleteCarriersApiResponse,
            DeleteCarriersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Carrier/Admin/${queryArg.carrierId}`,
                method: 'DELETE',
            }),
        }),
        activateCarriers: build.mutation<
            ActivateCarriersApiResponse,
            ActivateCarriersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Carrier/Admin/${queryArg.carrierId}/Active`,
                method: 'PUT',
                body: queryArg.carrierActiveVm,
            }),
        }),
        getAllCarrierContacts: build.query<
            GetAllCarrierContactsApiResponse,
            GetAllCarrierContactsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrierContact`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        createCarrierContacts: build.mutation<
            CreateCarrierContactsApiResponse,
            CreateCarrierContactsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrierContact`,
                method: 'POST',
                body: queryArg.carrierContactVm,
            }),
        }),
        getCarrierContactById: build.query<
            GetCarrierContactByIdApiResponse,
            GetCarrierContactByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrierContact/${queryArg.carrierId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        modifyCarrierContacts: build.mutation<
            ModifyCarrierContactsApiResponse,
            ModifyCarrierContactsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrierContact/${queryArg.contactId}`,
                method: 'PUT',
                body: queryArg.carrierContactVm,
            }),
        }),
        deleteCarrierContacts: build.mutation<
            DeleteCarrierContactsApiResponse,
            DeleteCarrierContactsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrierContact/${queryArg.contactId}`,
                method: 'DELETE',
            }),
        }),
        getCarrierModeMapsById: build.query<
            GetCarrierModeMapsByIdApiResponse,
            GetCarrierModeMapsByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrierModeMap/${queryArg.carrierId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        createCarrierModeMaps: build.mutation<
            CreateCarrierModeMapsApiResponse,
            CreateCarrierModeMapsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrierModeMap`,
                method: 'POST',
                body: queryArg.carrierModeMapVm,
            }),
        }),
        modifyCarrierModeMaps: build.mutation<
            ModifyCarrierModeMapsApiResponse,
            ModifyCarrierModeMapsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrierModeMap/${queryArg.mapId}`,
                method: 'PUT',
                body: queryArg.carrierModeMapVm,
            }),
        }),
        deleteCarrierModeMaps: build.mutation<
            DeleteCarrierModeMapsApiResponse,
            DeleteCarrierModeMapsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrierModeMap/${queryArg.mapId}`,
                method: 'DELETE',
            }),
        }),
        getPayMethodsForCarrier: build.query<
            GetPayMethodsForCarrierApiResponse,
            GetPayMethodsForCarrierApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrierPaymentRemit/${queryArg.carrierId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        createCarrierPayRemit: build.mutation<
            CreateCarrierPayRemitApiResponse,
            CreateCarrierPayRemitApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrierPaymentRemit`,
                method: 'POST',
                body: queryArg.carrierPaymentRemitVm,
            }),
        }),
        modifyCarrierPayRemit: build.mutation<
            ModifyCarrierPayRemitApiResponse,
            ModifyCarrierPayRemitApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrierPaymentRemit/${queryArg.remitInfoId}`,
                method: 'PUT',
                body: queryArg.carrierPaymentRemitVm,
            }),
        }),
        deleteCarrierPayRemit: build.mutation<
            DeleteCarrierPayRemitApiResponse,
            DeleteCarrierPayRemitApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrierPaymentRemit/${queryArg.remitInfoId}`,
                method: 'DELETE',
            }),
        }),
        getCarrierRemitMethods: build.query<
            GetCarrierRemitMethodsApiResponse,
            GetCarrierRemitMethodsApiArg
        >({
            query: () => ({url: `/api/CarrierPaymentRemit/RemitMethods`}),
        }),
        getCarrierRemitDeliveryMethods: build.query<
            GetCarrierRemitDeliveryMethodsApiResponse,
            GetCarrierRemitDeliveryMethodsApiArg
        >({
            query: () => ({
                url: `/api/CarrierPaymentRemit/RemitDeliveryMethods`,
            }),
        }),
        getCarrierRemitFormats: build.query<
            GetCarrierRemitFormatsApiResponse,
            GetCarrierRemitFormatsApiArg
        >({
            query: () => ({url: `/api/CarrierPaymentRemit/RemitFormats`}),
        }),
        getAchSecCodes: build.query<
            GetAchSecCodesApiResponse,
            GetAchSecCodesApiArg
        >({
            query: () => ({url: `/api/CarrierPaymentRemit/ACHSecCodes`}),
        }),
        getCarrierInvoiceById: build.query<
            GetCarrierInvoiceByIdApiResponse,
            GetCarrierInvoiceByIdApiArg
        >({
            query: (queryArg) => ({url: `/api/CarrInv/${queryArg.id}`}),
        }),
        getInvoiceSummary: build.query<
            GetInvoiceSummaryApiResponse,
            GetInvoiceSummaryApiArg
        >({
            query: (queryArg) => ({url: `/api/CarrInv/${queryArg.id}/Summary`}),
        }),
        getInvoiceLineSummary: build.query<
            GetInvoiceLineSummaryApiResponse,
            GetInvoiceLineSummaryApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrInv/${queryArg.id}/LineSummary`,
            }),
        }),
        getInvoiceChargeDetails: build.query<
            GetInvoiceChargeDetailsApiResponse,
            GetInvoiceChargeDetailsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrInv/${queryArg.id}/ChargeDetails`,
            }),
        }),
        getInvoiceLineChargeDetails: build.query<
            GetInvoiceLineChargeDetailsApiResponse,
            GetInvoiceLineChargeDetailsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrInv/${queryArg.id}/LineChargeDetails`,
            }),
        }),
        create: build.mutation<CreateApiResponse, CreateApiArg>({
            query: (queryArg) => ({
                url: `/api/CarrInv`,
                method: 'POST',
                body: queryArg.carrInvVm,
            }),
        }),
        initiateMultiPartInvoiceCreation: build.mutation<
            InitiateMultiPartInvoiceCreationApiResponse,
            InitiateMultiPartInvoiceCreationApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrInv/InitiateMultiPartInvoiceCreation`,
                method: 'POST',
                body: queryArg.initiateMultiPartInvoiceCreationRequest,
            }),
        }),
        multiPartInvoiceCreation: build.mutation<
            MultiPartInvoiceCreationApiResponse,
            MultiPartInvoiceCreationApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrInv/MultiPartInvoiceCreation`,
                method: 'POST',
                body: queryArg.invoicePartRequest,
            }),
        }),
        completeMultiPartInvoiceCreation: build.mutation<
            CompleteMultiPartInvoiceCreationApiResponse,
            CompleteMultiPartInvoiceCreationApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrInv/CompleteMultiPartInvoiceCreation`,
                method: 'POST',
                body: queryArg.completeMultiPartInvoiceCreationRequest,
            }),
        }),
        abortMultiPartInvoiceCreation: build.mutation<
            AbortMultiPartInvoiceCreationApiResponse,
            AbortMultiPartInvoiceCreationApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrInv/AbortMultiPartInvoiceCreation`,
                method: 'POST',
                body: queryArg.abortMultiPartInvoiceCreationRequest,
            }),
        }),
        createQueued: build.mutation<
            CreateQueuedApiResponse,
            CreateQueuedApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrInv/queued`,
                method: 'POST',
                body: queryArg.carrInvVm,
            }),
        }),
        postApiCarrInvCheckQueuedInvoiceCreationState: build.mutation<
            PostApiCarrInvCheckQueuedInvoiceCreationStateApiResponse,
            PostApiCarrInvCheckQueuedInvoiceCreationStateApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrInv/CheckQueuedInvoiceCreationState`,
                method: 'POST',
                body: queryArg.invoiceCreationStatusRequest,
            }),
        }),
        validateCoding: build.mutation<
            ValidateCodingApiResponse,
            ValidateCodingApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrInv/${queryArg.id}/ValidateCoding`,
                method: 'POST',
                params: {
                    isSave: queryArg.isSave,
                    isFromApp: queryArg.isFromApp,
                },
            }),
        }),
        validateLineCoding: build.mutation<
            ValidateLineCodingApiResponse,
            ValidateLineCodingApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrInv/${queryArg.id}/ValidateCoding/${queryArg.lineIdx}`,
                method: 'POST',
                params: {
                    isSave: queryArg.isSave,
                    isFromApp: queryArg.isFromApp,
                },
            }),
        }),
        createBillingInvoice: build.mutation<
            CreateBillingInvoiceApiResponse,
            CreateBillingInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrInv/${queryArg.id}/CreateBillingInvoice`,
                method: 'POST',
                params: {
                    handledInvoiceException: queryArg.handledInvoiceException,
                    createPdf: queryArg.createPdf,
                    createDupeIfExists: queryArg.createDupeIfExists,
                },
            }),
        }),
        createBillingInvoiceQueued: build.mutation<
            CreateBillingInvoiceQueuedApiResponse,
            CreateBillingInvoiceQueuedApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrInv/${queryArg.id}/CreateBillingInvoice/queued`,
                method: 'POST',
                params: {
                    handledInvoiceException: queryArg.handledInvoiceException,
                    createPdf: queryArg.createPdf,
                },
            }),
        }),
        createPdfInvoice: build.mutation<
            CreatePdfInvoiceApiResponse,
            CreatePdfInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrInv/${queryArg.id}/CreatePdfInvoice`,
                method: 'POST',
            }),
        }),
        createPdfInvoiceQueued: build.mutation<
            CreatePdfInvoiceQueuedApiResponse,
            CreatePdfInvoiceQueuedApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrInv/${queryArg.id}/CreatePdfInvoice/queued`,
                method: 'POST',
            }),
        }),
        regeneratePdfInvoice: build.mutation<
            RegeneratePdfInvoiceApiResponse,
            RegeneratePdfInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrInv/${queryArg.id}/RegeneratePdfInvoice/queued`,
                method: 'POST',
            }),
        }),
        getImagesForInvoice: build.query<
            GetImagesForInvoiceApiResponse,
            GetImagesForInvoiceApiArg
        >({
            query: (queryArg) => ({url: `/api/CarrInv/${queryArg.id}/Images`}),
        }),
        addImage: build.mutation<AddImageApiResponse, AddImageApiArg>({
            query: (queryArg) => ({
                url: `/api/CarrInv/${queryArg.id}/Images`,
                method: 'POST',
                body: queryArg.carrierInvoiceImagesVm,
            }),
        }),
        clearCachedImagesForInvoice: build.mutation<
            ClearCachedImagesForInvoiceApiResponse,
            ClearCachedImagesForInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrInv/${queryArg.id}/Images/ClearCachedImages`,
                method: 'POST',
            }),
        }),
        getImageWithData: build.query<
            GetImageWithDataApiResponse,
            GetImageWithDataApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrInv/${queryArg.id}/Images/${queryArg.imageId}`,
            }),
        }),
        getImageWithDataFromObject: build.mutation<
            GetImageWithDataFromObjectApiResponse,
            GetImageWithDataFromObjectApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrInv/${queryArg.id}/Images/${queryArg.imageId}/obj`,
                method: 'POST',
                body: queryArg.carrierInvoiceImagesVm,
            }),
        }),
        carrInvDisconnectImage: build.mutation<
            CarrInvDisconnectImageApiResponse,
            CarrInvDisconnectImageApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrInv/${queryArg.id}/Images/${queryArg.imageId}/Disconnect`,
                method: 'PUT',
            }),
        }),
        whatIfChargeCodesForNewBillto: build.query<
            WhatIfChargeCodesForNewBilltoApiResponse,
            WhatIfChargeCodesForNewBilltoApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrInv/${queryArg.id}/ChargeCodeWhatIf/${queryArg.newBillToId}`,
            }),
        }),
        getAllCarrServices: build.query<
            GetAllCarrServicesApiResponse,
            GetAllCarrServicesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrServices`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        createCarrierServices: build.mutation<
            CreateCarrierServicesApiResponse,
            CreateCarrierServicesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrServices`,
                method: 'POST',
                body: queryArg.carrServicesVm,
            }),
        }),
        getCarrierServicesById: build.query<
            GetCarrierServicesByIdApiResponse,
            GetCarrierServicesByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrServices/${queryArg.carrierId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        modifyCarrierService: build.mutation<
            ModifyCarrierServiceApiResponse,
            ModifyCarrierServiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrServices/${queryArg.carrierId}/${queryArg.svcCode}`,
                method: 'PUT',
                body: queryArg.carrServicesVm,
            }),
        }),
        deleteCarrierServices: build.mutation<
            DeleteCarrierServicesApiResponse,
            DeleteCarrierServicesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CarrServices/${queryArg.carrierId}/${queryArg.svcCode}`,
                method: 'DELETE',
            }),
        }),
        getAllowedCarrSvcAuditFns: build.query<
            GetAllowedCarrSvcAuditFnsApiResponse,
            GetAllowedCarrSvcAuditFnsApiArg
        >({
            query: () => ({url: `/api/CarrServices/Functions`}),
        }),
        getAllCmContracts: build.query<
            GetAllCmContractsApiResponse,
            GetAllCmContractsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CmContract`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        createCmContracts: build.mutation<
            CreateCmContractsApiResponse,
            CreateCmContractsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CmContract`,
                method: 'POST',
                body: queryArg.cmContractVm,
            }),
        }),
        modifyCmContracts: build.mutation<
            ModifyCmContractsApiResponse,
            ModifyCmContractsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CmContract/${queryArg.carrier}/${queryArg.customer}/${queryArg.service}`,
                method: 'PUT',
                body: queryArg.cmContractVm,
            }),
        }),
        deleteCmContracts: build.mutation<
            DeleteCmContractsApiResponse,
            DeleteCmContractsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CmContract/${queryArg.carrier}/${queryArg.customer}/${queryArg.service}`,
                method: 'DELETE',
            }),
        }),
        getAllMasterCodes: build.query<
            GetAllMasterCodesApiResponse,
            GetAllMasterCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CodeMaster`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        getMasterCodesForElement: build.query<
            GetMasterCodesForElementApiResponse,
            GetMasterCodesForElementApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CodeMaster/${queryArg.element}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        modifyMasterCodes: build.mutation<
            ModifyMasterCodesApiResponse,
            ModifyMasterCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CodeMaster/${queryArg.element}/${queryArg.code}`,
                method: 'PUT',
                body: queryArg.codeMasterVm,
            }),
        }),
        getMasterCodeFilters: build.query<
            GetMasterCodeFiltersApiResponse,
            GetMasterCodeFiltersApiArg
        >({
            query: () => ({url: `/api/CodeMaster/Filters`}),
        }),
        getActiveCurrencyCodes: build.query<
            GetActiveCurrencyCodesApiResponse,
            GetActiveCurrencyCodesApiArg
        >({
            query: () => ({url: `/api/CodeMaster/CurrencyCodes`}),
        }),
        getAuditFailCodes: build.query<
            GetAuditFailCodesApiResponse,
            GetAuditFailCodesApiArg
        >({
            query: () => ({url: `/api/CodeMaster/AuditFailCodes`}),
        }),
        getCustomerContactsById: build.query<
            GetCustomerContactsByIdApiResponse,
            GetCustomerContactsByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Contact/${queryArg.customerId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        createCustomerContacts: build.mutation<
            CreateCustomerContactsApiResponse,
            CreateCustomerContactsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Contact`,
                method: 'POST',
                body: queryArg.contactsVm,
            }),
        }),
        modifyCustomerContacts: build.mutation<
            ModifyCustomerContactsApiResponse,
            ModifyCustomerContactsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Contact/${queryArg.contactId}`,
                method: 'PUT',
                body: queryArg.contactsVm,
            }),
        }),
        deleteCustomerContacts: build.mutation<
            DeleteCustomerContactsApiResponse,
            DeleteCustomerContactsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Contact/${queryArg.contactId}`,
                method: 'DELETE',
            }),
        }),
        getAllCurrencies: build.query<
            GetAllCurrenciesApiResponse,
            GetAllCurrenciesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Currencies`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        getRefDefs: build.query<GetRefDefsApiResponse, GetRefDefsApiArg>({
            query: (queryArg) => ({
                url: `/api/CustomerDataEntry/${queryArg.customerId}/${queryArg.carrierId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        createRefDef: build.mutation<
            CreateRefDefApiResponse,
            CreateRefDefApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CustomerDataEntry`,
                method: 'POST',
                body: queryArg.customerDataEntryVm,
            }),
        }),
        modifyRefDef: build.mutation<
            ModifyRefDefApiResponse,
            ModifyRefDefApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CustomerDataEntry/${queryArg.defId}`,
                method: 'PUT',
                body: queryArg.customerDataEntryVm,
            }),
        }),
        deleteRefDef: build.mutation<
            DeleteRefDefApiResponse,
            DeleteRefDefApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CustomerDataEntry/${queryArg.defId}`,
                method: 'DELETE',
            }),
        }),
        createReceivableBatchesForCustomers: build.mutation<
            CreateReceivableBatchesForCustomersApiResponse,
            CreateReceivableBatchesForCustomersApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CustomerInvoice/CreateReceivableBatchesForCustomers`,
                method: 'POST',
                body: queryArg.createReceivableBatchesForCustomersVm,
            }),
        }),
        createReceivableBatchesFromInvoices: build.mutation<
            CreateReceivableBatchesFromInvoicesApiResponse,
            CreateReceivableBatchesFromInvoicesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CustomerInvoice/CreateReceivableBatchesFromInvoices`,
                method: 'POST',
                body: queryArg.body,
            }),
        }),
        getList: build.query<GetListApiResponse, GetListApiArg>({
            query: () => ({url: `/api/CustPay`}),
        }),
        upsert: build.mutation<UpsertApiResponse, UpsertApiArg>({
            query: (queryArg) => ({
                url: `/api/CustPay`,
                method: 'POST',
                body: queryArg.custPaySetupVm,
            }),
        }),
        getCustPayByBillToIdById: build.query<
            GetCustPayByBillToIdByIdApiResponse,
            GetCustPayByBillToIdByIdApiArg
        >({
            query: (queryArg) => ({url: `/api/CustPay/btid/${queryArg.id}`}),
        }),
        getCustPaySetupById: build.query<
            GetCustPaySetupByIdApiResponse,
            GetCustPaySetupByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CustPay/${queryArg.customerId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        createCustPaySetup: build.mutation<
            CreateCustPaySetupApiResponse,
            CreateCustPaySetupApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CustPay/${queryArg.customerId}`,
                method: 'POST',
                body: queryArg.custPaySetupVm,
            }),
        }),
        modifyCustPaySetup: build.mutation<
            ModifyCustPaySetupApiResponse,
            ModifyCustPaySetupApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CustPay/${queryArg.setupId}`,
                method: 'PUT',
                body: queryArg.custPaySetupVm,
            }),
        }),
        deleteCustPaySetup: build.mutation<
            DeleteCustPaySetupApiResponse,
            DeleteCustPaySetupApiArg
        >({
            query: (queryArg) => ({
                url: `/api/CustPay/${queryArg.setupId}`,
                method: 'DELETE',
            }),
        }),
        getShipmentCountByStatus: build.query<
            GetShipmentCountByStatusApiResponse,
            GetShipmentCountByStatusApiArg
        >({
            query: () => ({url: `/api/Dashboard/ShipmentCountByStatus`}),
        }),
        getAgedInvoiceSummary: build.query<
            GetAgedInvoiceSummaryApiResponse,
            GetAgedInvoiceSummaryApiArg
        >({
            query: () => ({url: `/api/Dashboard/AgedInvoiceSummary`}),
        }),
        getDataEntryAdminInfoByCustomer: build.query<
            GetDataEntryAdminInfoByCustomerApiResponse,
            GetDataEntryAdminInfoByCustomerApiArg
        >({
            query: (queryArg) => ({
                url: `/api/DataEntryAdmin/${queryArg.customerId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        createDataEntryAdminInfo: build.mutation<
            CreateDataEntryAdminInfoApiResponse,
            CreateDataEntryAdminInfoApiArg
        >({
            query: (queryArg) => ({
                url: `/api/DataEntryAdmin`,
                method: 'POST',
                body: queryArg.deAdminVm,
            }),
        }),
        modifyDataEntryAdminInfo: build.mutation<
            ModifyDataEntryAdminInfoApiResponse,
            ModifyDataEntryAdminInfoApiArg
        >({
            query: (queryArg) => ({
                url: `/api/DataEntryAdmin/${queryArg.customerId}/${queryArg.carrierId}`,
                method: 'PUT',
                body: queryArg.deAdminVm,
            }),
        }),
        deleteDataEntryAdminInfo: build.mutation<
            DeleteDataEntryAdminInfoApiResponse,
            DeleteDataEntryAdminInfoApiArg
        >({
            query: (queryArg) => ({
                url: `/api/DataEntryAdmin/${queryArg.customerId}/${queryArg.carrierId}`,
                method: 'DELETE',
            }),
        }),
        invoiceResearchExport: build.mutation<
            InvoiceResearchExportApiResponse,
            InvoiceResearchExportApiArg
        >({
            query: (queryArg) => ({
                url: `/api/DataExport/InvoiceResearchExport`,
                method: 'POST',
                body: queryArg.invoiceResearchOptionsVm,
                params: {
                    userJobName: queryArg.userJobName,
                    fileFormat: queryArg.fileFormat,
                },
            }),
        }),
        getDataExports: build.query<
            GetDataExportsApiResponse,
            GetDataExportsApiArg
        >({
            query: () => ({url: `/api/DataExport`}),
        }),
        deleteExport: build.mutation<
            DeleteExportApiResponse,
            DeleteExportApiArg
        >({
            query: (queryArg) => ({
                url: `/api/DataExport/${queryArg.id}`,
                method: 'DELETE',
            }),
        }),
        sendMailWithOutAttachments: build.mutation<
            SendMailWithOutAttachmentsApiResponse,
            SendMailWithOutAttachmentsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Email`,
                method: 'POST',
                body: queryArg.emailVm,
            }),
        }),
        bulkCoding: build.mutation<BulkCodingApiResponse, BulkCodingApiArg>({
            query: (queryArg) => ({
                url: `/api/GlCoding/Bulk`,
                method: 'POST',
                body: queryArg.glBulkCodingRequest,
            }),
        }),
        getGlCodeForInvoice: build.mutation<
            GetGlCodeForInvoiceApiResponse,
            GetGlCodeForInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/GlCoding/Invoice`,
                method: 'POST',
                body: queryArg.glCodingRequest,
            }),
        }),
        postHopkinsDepartment: build.mutation<
            PostHopkinsDepartmentApiResponse,
            PostHopkinsDepartmentApiArg
        >({
            query: (queryArg) => ({
                url: `/api/GlCoding/DetermineHopkinsDepartment`,
                method: 'POST',
                body: queryArg.hopkinsDepartmentVm,
            }),
        }),
        getHealthCheck: build.query<
            GetHealthCheckApiResponse,
            GetHealthCheckApiArg
        >({
            query: () => ({url: `/health/check`}),
        }),
        get: build.query<GetApiResponse, GetApiArg>({
            query: () => ({url: `/`}),
        }),
        getImage: build.query<GetImageApiResponse, GetImageApiArg>({
            query: (queryArg) => ({url: `/api/Images/${queryArg.imageId}`}),
        }),
        deleteImage: build.mutation<DeleteImageApiResponse, DeleteImageApiArg>({
            query: (queryArg) => ({
                url: `/api/Images/${queryArg.imageId}`,
                method: 'DELETE',
            }),
        }),
        disconnectImage: build.mutation<
            DisconnectImageApiResponse,
            DisconnectImageApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Images/${queryArg.imageId}/Disconnect`,
                method: 'PUT',
            }),
        }),
        getDisconnectedImages: build.query<
            GetDisconnectedImagesApiResponse,
            GetDisconnectedImagesApiArg
        >({
            query: () => ({url: `/api/Images/DisconnectedImages`}),
        }),
        uploadDisconnectedImage: build.mutation<
            UploadDisconnectedImageApiResponse,
            UploadDisconnectedImageApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Images/DisconnectedImages`,
                method: 'POST',
                body: queryArg.carrierInvoiceImagesVm,
            }),
        }),
        releaseInvoice: build.mutation<
            ReleaseInvoiceApiResponse,
            ReleaseInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/InvoiceEdit/${queryArg['type']}/${queryArg.id}/release`,
                method: 'PATCH',
            }),
        }),
        getBasicInvInfo: build.mutation<
            GetBasicInvInfoApiResponse,
            GetBasicInvInfoApiArg
        >({
            query: (queryArg) => ({
                url: `/api/InvoiceEdit/${queryArg['type']}/${queryArg.id}/basicinfo`,
                method: 'GET',
            }),
        }),
        getDetailedCharges: build.query<
            GetDetailedChargesApiResponse,
            GetDetailedChargesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/InvoiceEdit/${queryArg['type']}/${queryArg.id}/detailedcharges`,
            }),
        }),
        getReferences: build.query<
            GetReferencesApiResponse,
            GetReferencesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/InvoiceEdit/${queryArg['type']}/${queryArg.id}/references`,
            }),
        }),
        updateReferences: build.mutation<
            UpdateReferencesApiResponse,
            UpdateReferencesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/InvoiceEdit/${queryArg['type']}/${queryArg.id}/references`,
                method: 'PUT',
                body: queryArg.referenceListVm,
            }),
        }),
        getImages: build.query<GetImagesApiResponse, GetImagesApiArg>({
            query: (queryArg) => ({
                url: `/api/InvoiceEdit/${queryArg['type']}/${queryArg.id}/images`,
            }),
        }),
        updateComment: build.mutation<
            UpdateCommentApiResponse,
            UpdateCommentApiArg
        >({
            query: (queryArg) => ({
                url: `/api/InvoiceEdit/${queryArg['type']}/${queryArg.id}/comments`,
                method: 'PATCH',
                body: queryArg.invoiceComment,
            }),
        }),
        getInvoiceResearchPopulationData: build.query<
            GetInvoiceResearchPopulationDataApiResponse,
            GetInvoiceResearchPopulationDataApiArg
        >({
            query: () => ({url: `/api/InvoiceResearch`}),
        }),
        searchInvoices: build.mutation<
            SearchInvoicesApiResponse,
            SearchInvoicesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/InvoiceResearch`,
                method: 'POST',
                body: queryArg.invoiceResearchOptionsVm,
            }),
        }),
        reactDataTableServerSideProcessing: build.mutation<
            ReactDataTableServerSideProcessingApiResponse,
            ReactDataTableServerSideProcessingApiArg
        >({
            query: (queryArg) => ({
                url: `/api/InvoiceResearch/reactdatatable`,
                method: 'POST',
                body: queryArg.invoiceResearchOptionsVm,
            }),
        }),
        getMakeRealWorkaroundInvoices: build.query<
            GetMakeRealWorkaroundInvoicesApiResponse,
            GetMakeRealWorkaroundInvoicesApiArg
        >({
            query: () => ({url: `/api/ItAdmin/makeReal`}),
        }),
        postMakeRealWorkaroundInvoices: build.mutation<
            PostMakeRealWorkaroundInvoicesApiResponse,
            PostMakeRealWorkaroundInvoicesApiArg
        >({
            query: () => ({url: `/api/ItAdmin/makeReal`, method: 'POST'}),
        }),
        getStatusesForExceptions: build.query<
            GetStatusesForExceptionsApiResponse,
            GetStatusesForExceptionsApiArg
        >({
            query: () => ({url: `/api/ManageAuditException/GetAuditStatuses`}),
        }),
        getExceptionsForGrid: build.query<
            GetExceptionsForGridApiResponse,
            GetExceptionsForGridApiArg
        >({
            query: (queryArg) => ({
                url: `/api/ManageAuditException`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        saveCurrentRemarks: build.mutation<
            SaveCurrentRemarksApiResponse,
            SaveCurrentRemarksApiArg
        >({
            query: (queryArg) => ({
                url: `/api/ManageAuditException/SaveRemarks`,
                method: 'POST',
                body: queryArg.exceptionManagerActionVm,
            }),
        }),
        acceptAsEntered: build.mutation<
            AcceptAsEnteredApiResponse,
            AcceptAsEnteredApiArg
        >({
            query: (queryArg) => ({
                url: `/api/ManageAuditException/AcceptAsEntered`,
                method: 'POST',
                body: queryArg.exceptionManagerActionVm,
            }),
        }),
        acceptAsAudited: build.mutation<
            AcceptAsAuditedApiResponse,
            AcceptAsAuditedApiArg
        >({
            query: (queryArg) => ({
                url: `/api/ManageAuditException/AcceptAsAudited`,
                method: 'POST',
                body: queryArg.exceptionManagerActionVm,
            }),
        }),
        acceptAsAdjusted: build.mutation<
            AcceptAsAdjustedApiResponse,
            AcceptAsAdjustedApiArg
        >({
            query: (queryArg) => ({
                url: `/api/ManageAuditException/AcceptAsAdjusted`,
                method: 'POST',
                body: queryArg.exceptionManagerAcceptAsAdjustedVm,
            }),
        }),
        refuseInvoice: build.mutation<
            RefuseInvoiceApiResponse,
            RefuseInvoiceApiArg
        >({
            query: (queryArg) => ({
                url: `/api/ManageAuditException/RefuseInvoice`,
                method: 'POST',
                body: queryArg.exceptionManagerActionVm,
            }),
        }),
        exceptionManagerDelete: build.mutation<
            ExceptionManagerDeleteApiResponse,
            ExceptionManagerDeleteApiArg
        >({
            query: (queryArg) => ({
                url: `/api/ManageAuditException/DeleteInvoice`,
                method: 'POST',
                body: queryArg.exceptionManagerActionVm,
            }),
        }),
        getAvailableAuditFailStatuses: build.query<
            GetAvailableAuditFailStatusesApiResponse,
            GetAvailableAuditFailStatusesApiArg
        >({
            query: () => ({url: `/api/MetaInformation/Status/AuditFail`}),
        }),
        getCarrierChargeCodeSources: build.query<
            GetCarrierChargeCodeSourcesApiResponse,
            GetCarrierChargeCodeSourcesApiArg
        >({
            query: () => ({
                url: `/api/MetaInformation/CarrierChargeCodeSource`,
            }),
        }),
        getCustomerDataEntryCodesForUser: build.query<
            GetCustomerDataEntryCodesForUserApiResponse,
            GetCustomerDataEntryCodesForUserApiArg
        >({
            query: () => ({url: `/api/MetaInformation/CustomerDataEntryCodes`}),
        }),
        getCustomerDataEntryCodes: build.query<
            GetCustomerDataEntryCodesApiResponse,
            GetCustomerDataEntryCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/MetaInformation/CustomerDataEntryCodes/${queryArg.billToId}`,
            }),
        }),
        getIa360ReportingLink: build.query<
            GetIa360ReportingLinkApiResponse,
            GetIa360ReportingLinkApiArg
        >({
            query: (queryArg) => ({
                url: `/api/MetaInformation/ia360reportinglink`,
                params: {
                    carrierId: queryArg.carrierId,
                    invoiceNum: queryArg.invoiceNum,
                },
            }),
        }),
        getInvoiceStatusCodes: build.query<
            GetInvoiceStatusCodesApiResponse,
            GetInvoiceStatusCodesApiArg
        >({
            query: () => ({url: `/api/MetaInformation/InvoiceStatusCodes`}),
        }),
        getEntryMethods: build.query<
            GetEntryMethodsApiResponse,
            GetEntryMethodsApiArg
        >({
            query: () => ({url: `/api/MetaInformation/EntryMethods`}),
        }),
        getActivityCodes: build.query<
            GetActivityCodesApiResponse,
            GetActivityCodesApiArg
        >({
            query: () => ({url: `/api/MetaInformation/ActivityCodes`}),
        }),
        getAscRefCodes: build.query<
            GetAscRefCodesApiResponse,
            GetAscRefCodesApiArg
        >({
            query: () => ({url: `/api/MetaInformation/AscRefCodes`}),
        }),
        getAscChargeCodes: build.query<
            GetAscChargeCodesApiResponse,
            GetAscChargeCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/MetaInformation/AscChargeCodes`,
                params: {sorted: queryArg.sorted},
            }),
        }),
        getTransportModes: build.query<
            GetTransportModesApiResponse,
            GetTransportModesApiArg
        >({
            query: () => ({url: `/api/MetaInformation/Modes`}),
        }),
        getInvoiceTypeList: build.query<
            GetInvoiceTypeListApiResponse,
            GetInvoiceTypeListApiArg
        >({
            query: () => ({url: `/api/MetaInformation/InvoiceTypes`}),
        }),
        getCarrierPayableExceptionsById: build.query<
            GetCarrierPayableExceptionsByIdApiResponse,
            GetCarrierPayableExceptionsByIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/PayablesExceptions/${queryArg.carrierId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        createCarrierPayException: build.mutation<
            CreateCarrierPayExceptionApiResponse,
            CreateCarrierPayExceptionApiArg
        >({
            query: (queryArg) => ({
                url: `/api/PayablesExceptions`,
                method: 'POST',
                body: queryArg.payablesExceptionsVm,
            }),
        }),
        modifyCarrierPayException: build.mutation<
            ModifyCarrierPayExceptionApiResponse,
            ModifyCarrierPayExceptionApiArg
        >({
            query: (queryArg) => ({
                url: `/api/PayablesExceptions/${queryArg.exceptionId}`,
                method: 'PUT',
                body: queryArg.payablesExceptionsVm,
            }),
        }),
        deleteCarrierPayException: build.mutation<
            DeleteCarrierPayExceptionApiResponse,
            DeleteCarrierPayExceptionApiArg
        >({
            query: (queryArg) => ({
                url: `/api/PayablesExceptions/${queryArg.exceptionId}`,
                method: 'DELETE',
            }),
        }),
        getAllPayDayStarts: build.query<
            GetAllPayDayStartsApiResponse,
            GetAllPayDayStartsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/PayDaysStart`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        getPermittedValsByCustomer: build.query<
            GetPermittedValsByCustomerApiResponse,
            GetPermittedValsByCustomerApiArg
        >({
            query: (queryArg) => ({
                url: `/api/PermittedValues/${queryArg.customerId}/${queryArg.carrierId}/${queryArg.code}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        createPermittedValue: build.mutation<
            CreatePermittedValueApiResponse,
            CreatePermittedValueApiArg
        >({
            query: (queryArg) => ({
                url: `/api/PermittedValues`,
                method: 'POST',
                body: queryArg.permittedValuesVm,
            }),
        }),
        modifyPermittedValue: build.mutation<
            ModifyPermittedValueApiResponse,
            ModifyPermittedValueApiArg
        >({
            query: (queryArg) => ({
                url: `/api/PermittedValues/${queryArg.valId}`,
                method: 'PUT',
                body: queryArg.permittedValuesVm,
            }),
        }),
        deletePermittedValue: build.mutation<
            DeletePermittedValueApiResponse,
            DeletePermittedValueApiArg
        >({
            query: (queryArg) => ({
                url: `/api/PermittedValues/${queryArg.valId}`,
                method: 'DELETE',
            }),
        }),
        getPostalCodes: build.query<
            GetPostalCodesApiResponse,
            GetPostalCodesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/PostalCode`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        createPostalCode: build.mutation<
            CreatePostalCodeApiResponse,
            CreatePostalCodeApiArg
        >({
            query: (queryArg) => ({
                url: `/api/PostalCode`,
                method: 'POST',
                body: queryArg.postalCodeVm,
            }),
        }),
        modifyPostalCode: build.mutation<
            ModifyPostalCodeApiResponse,
            ModifyPostalCodeApiArg
        >({
            query: (queryArg) => ({
                url: `/api/PostalCode/${queryArg.codeId}`,
                method: 'PUT',
                body: queryArg.postalCodeVm,
            }),
        }),
        deletePostalCode: build.mutation<
            DeletePostalCodeApiResponse,
            DeletePostalCodeApiArg
        >({
            query: (queryArg) => ({
                url: `/api/PostalCode/${queryArg.codeId}`,
                method: 'DELETE',
            }),
        }),
        getStates: build.query<GetStatesApiResponse, GetStatesApiArg>({
            query: (queryArg) => ({
                url: `/api/States`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        createStates: build.mutation<
            CreateStatesApiResponse,
            CreateStatesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/States`,
                method: 'POST',
                body: queryArg.statesVm,
            }),
        }),
        modifyStates: build.mutation<
            ModifyStatesApiResponse,
            ModifyStatesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/States/${queryArg.stateId}`,
                method: 'PUT',
                body: queryArg.statesVm,
            }),
        }),
        deleteStates: build.mutation<
            DeleteStatesApiResponse,
            DeleteStatesApiArg
        >({
            query: (queryArg) => ({
                url: `/api/States/${queryArg.stateId}`,
                method: 'DELETE',
            }),
        }),
        getTimecardForUserId: build.query<
            GetTimecardForUserIdApiResponse,
            GetTimecardForUserIdApiArg
        >({
            query: (queryArg) => ({
                url: `/api/TimeCard`,
                params: {userId: queryArg.userId, date: queryArg.date},
            }),
        }),
        addTimeCard: build.mutation<AddTimeCardApiResponse, AddTimeCardApiArg>({
            query: (queryArg) => ({
                url: `/api/TimeCard`,
                method: 'POST',
                body: queryArg.userTimeCardVm,
            }),
        }),
        deleteTimeCard: build.mutation<
            DeleteTimeCardApiResponse,
            DeleteTimeCardApiArg
        >({
            query: (queryArg) => ({url: `/${queryArg.id}`, method: 'DELETE'}),
        }),
        getUserBillToInfoByCustomer: build.query<
            GetUserBillToInfoByCustomerApiResponse,
            GetUserBillToInfoByCustomerApiArg
        >({
            query: (queryArg) => ({
                url: `/api/UserBillTo/${queryArg.customerId}`,
                params: {
                    $top: queryArg.$top,
                    $skip: queryArg.$skip,
                    $filter: queryArg.$filter,
                    $orderby: queryArg.$orderby,
                    $expand: queryArg.$expand,
                },
            }),
        }),
        createUserBillToInfo: build.mutation<
            CreateUserBillToInfoApiResponse,
            CreateUserBillToInfoApiArg
        >({
            query: (queryArg) => ({
                url: `/api/UserBillTo`,
                method: 'POST',
                body: queryArg.userBillToVm,
            }),
        }),
        deleteUserBillToInfo: build.mutation<
            DeleteUserBillToInfoApiResponse,
            DeleteUserBillToInfoApiArg
        >({
            query: (queryArg) => ({
                url: `/api/UserBillTo/${queryArg.customerId}/${queryArg.userId}`,
                method: 'DELETE',
            }),
        }),
        getMyConfig: build.query<GetMyConfigApiResponse, GetMyConfigApiArg>({
            query: () => ({url: `/api/UserConfig`}),
        }),
        saveMyConfig: build.mutation<
            SaveMyConfigApiResponse,
            SaveMyConfigApiArg
        >({
            query: (queryArg) => ({
                url: `/api/UserConfig`,
                method: 'PUT',
                body: queryArg.userConfigurationVm,
            }),
        }),
        getUserConfiguration: build.query<
            GetUserConfigurationApiResponse,
            GetUserConfigurationApiArg
        >({
            query: (queryArg) => ({url: `/api/UserConfig/${queryArg.userId}`}),
        }),
        saveUserConfig: build.mutation<
            SaveUserConfigApiResponse,
            SaveUserConfigApiArg
        >({
            query: (queryArg) => ({
                url: `/api/UserConfig/${queryArg.userId}`,
                method: 'PUT',
                body: queryArg.userConfigurationVm,
            }),
        }),
        getAllUsers: build.query<GetAllUsersApiResponse, GetAllUsersApiArg>({
            query: () => ({url: `/api/Users`}),
        }),
        getTimeCardUsers: build.query<
            GetTimeCardUsersApiResponse,
            GetTimeCardUsersApiArg
        >({
            query: () => ({url: `/api/Users/TimeCardUsers`}),
        }),
        getUserSessionsForUser: build.query<
            GetUserSessionsForUserApiResponse,
            GetUserSessionsForUserApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Users/Sessions/${queryArg.userId}`,
                params: {lastWorkDay: queryArg.lastWorkDay},
            }),
        }),
        getMyUserSessions: build.query<
            GetMyUserSessionsApiResponse,
            GetMyUserSessionsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Users/Sessions`,
                params: {lastWorkDay: queryArg.lastWorkDay},
            }),
        }),
        getCarrInvStatsForUser: build.query<
            GetCarrInvStatsForUserApiResponse,
            GetCarrInvStatsForUserApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Users/CarrInvStats/${queryArg.userId}`,
                params: {lastWorkDay: queryArg.lastWorkDay},
            }),
        }),
        getMyCarrInvStats: build.query<
            GetMyCarrInvStatsApiResponse,
            GetMyCarrInvStatsApiArg
        >({
            query: (queryArg) => ({
                url: `/api/Users/CarrInvStats`,
                params: {lastWorkDay: queryArg.lastWorkDay},
            }),
        }),
    }),
    overrideExisting: false,
});
export {injectedRtkApi as paylogikApi};
export type RequeueJobApiResponse = unknown;
export type RequeueJobApiArg = {
    queuedDataKey?: string;
    process?: string;
};
export type GetAppDefaultsApiResponse = unknown;
export type GetAppDefaultsApiArg = void;
export type PutAppDefaultsApiResponse = unknown;
export type PutAppDefaultsApiArg = {
    parmId: string;
    appDefaultVm: AppDefaultVm;
};
export type GetInvoicesApprovalPopulationDataApiResponse =
    /** status 200 Success */ InvoiceApprovalOptionsVm;
export type GetInvoicesApprovalPopulationDataApiArg = void;
export type GetInvoicesNeedingApprovalApiResponse =
    /** status 200 Success */ ApproveInvoicesSearchResponse;
export type GetInvoicesNeedingApprovalApiArg = {
    invoiceApprovalOptionsVm: InvoiceApprovalOptionsVm;
};
export type GetMinimalInvoiceDetailApiResponse =
    /** status 200 Success */ InvoiceSummaryVm;
export type GetMinimalInvoiceDetailApiArg = {
    id: number;
};
export type ApproveInvoicesApiResponse =
    /** status 200 Success */ ApproveInvoicesSearchResponse;
export type ApproveInvoicesApiArg = {
    approveInvoicesRequestVm: ApproveInvoicesRequestVm;
};
export type SaveCurrentInvoiceStateApiResponse =
    /** status 200 Success */ ApproveInvoicesSearchResponse;
export type SaveCurrentInvoiceStateApiArg = {
    approveInvoicesRequestVm: ApproveInvoicesRequestVm;
};
export type PostApiApproveInvoicesFromInvoiceIdxsApiResponse = unknown;
export type PostApiApproveInvoicesFromInvoiceIdxsApiArg = {
    body: number[];
};
export type GetAllAscChargeCodesApiResponse =
    /** status 200 Success */ AscChargeCodeVm[];
export type GetAllAscChargeCodesApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type CreateAscChargeCodesApiResponse =
    /** status 200 Success */ AscChargeCodeVm;
export type CreateAscChargeCodesApiArg = {
    /** AscChargeCodeVm object for the charge code to add */
    ascChargeCodeVm: AscChargeCodeVm;
};
export type ModifyAscChargeCodesApiResponse =
    /** status 200 Success */ AscChargeCodeVm;
export type ModifyAscChargeCodesApiArg = {
    /** ID of the charge code to update */
    codeId: string;
    /** AscChargeCodeVm object for the code to update */
    ascChargeCodeVm: AscChargeCodeVm;
};
export type DeleteAscChargeCodesApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteAscChargeCodesApiArg = {
    /** ID of the charge code to remove */
    codeId: string;
};
export type GetInvoiceChargeTypesApiResponse =
    /** status 200 Success */ InvoiceChargeTypeVm[];
export type GetInvoiceChargeTypesApiArg = void;
export type GetAllAscRefCodesApiResponse =
    /** status 200 Success */ AscReferenceCodeVm[];
export type GetAllAscRefCodesApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type CreateAscRefCodesApiResponse =
    /** status 200 Success */ AscReferenceCodeVm;
export type CreateAscRefCodesApiArg = {
    /** AscReferenceCodeVm object for the ref code to add */
    ascReferenceCodeVm: AscReferenceCodeVm;
};
export type ModifyAscRefCodesApiResponse =
    /** status 200 Success */ AscReferenceCodeVm;
export type ModifyAscRefCodesApiArg = {
    /** ID of the ref code to update */
    codeId: string;
    /** AscReferenceCodeVm object for the state to update */
    ascReferenceCodeVm: AscReferenceCodeVm;
};
export type DeleteAscRefCodesApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteAscRefCodesApiArg = {
    /** ID of the ref code to remove */
    codeId: string;
};
export type GetGenMilesApiResponse = /** status 200 Success */ number;
export type GetGenMilesApiArg = {
    auditMilesRequestVm: AuditMilesRequestVm;
};
export type LoginApiResponse = /** status 200 Success */ string;
export type LoginApiArg = {
    loginVm: LoginVm;
};
export type RefreshTokenApiResponse = /** status 200 Success */ string;
export type RefreshTokenApiArg = void;
export type LoginWithPermissionsApiResponse =
    /** status 200 Success */ LoginResponseVm;
export type LoginWithPermissionsApiArg = {
    loginVm: LoginVm;
};
export type RefreshWithPermissionsApiResponse =
    /** status 200 Success */ LoginResponseVm;
export type RefreshWithPermissionsApiArg = void;
export type LogOutApiResponse = unknown;
export type LogOutApiArg = void;
export type GetMyUserApiResponse = /** status 200 Success */ UserVm;
export type GetMyUserApiArg = void;
export type GetAllBankAccountsApiResponse =
    /** status 200 Success */ BankAccountVm[];
export type GetAllBankAccountsApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type GetBillToByIdApiResponse = /** status 200 Success */ BillToVm;
export type GetBillToByIdApiArg = {
    id: string;
};
export type GetDataEntryAscRefCodesApiResponse =
    /** status 200 Success */ CustomerDataEntryVm[];
export type GetDataEntryAscRefCodesApiArg = {
    id: string;
    carrierId: string;
};
export type GetAllBillToApiResponse =
    /** status 200 Success */ BillToMinimalVm[];
export type GetAllBillToApiArg = void;
export type GetBillToForDisplayApiResponse =
    /** status 200 Success */ BillToMinimalVm[];
export type GetBillToForDisplayApiArg = void;
export type GetCustomerByIdApiResponse = /** status 200 Success */ BillToVm;
export type GetCustomerByIdApiArg = {
    /** ID of the customer to load info on */
    customerId: string;
};
export type ModifyCustomersApiResponse = /** status 200 Success */ BillToVm;
export type ModifyCustomersApiArg = {
    /** ID of the customer to update */
    customerId: string;
    /** BillToVm object for the customer to update */
    billToVm: BillToVm;
};
export type DeleteCustomersApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCustomersApiArg = {
    /** ID of the customer to remove */
    customerId: string;
};
export type GetAllCustomersApiResponse = /** status 200 Success */ BillToVm[];
export type GetAllCustomersApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type CreateCustomersApiResponse = /** status 200 Success */ BillToVm;
export type CreateCustomersApiArg = {
    /** BillToVm object for the customer to add */
    billToVm: BillToVm;
};
export type GetParentCustomersApiResponse =
    /** status 200 Success */ BillToVm[];
export type GetParentCustomersApiArg = void;
export type ActivateCustomersApiResponse = /** status 200 Success */
    | BillToVm
    | /** status 204 Update completed */ undefined;
export type ActivateCustomersApiArg = {
    /** ID of the customer to update */
    customerId: string;
    /** BillToActiveVm object for the customer to update */
    billToActiveVm: BillToActiveVm;
};
export type GetModeDefaultsByCustomerApiResponse =
    /** status 200 Success */ BillToModeDefaultVm[];
export type GetModeDefaultsByCustomerApiArg = {
    /** ID of the customer to load mode default info for */
    customerId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type CreateBillToModeDefaultApiResponse =
    /** status 200 Success */ BillToModeDefaultVm;
export type CreateBillToModeDefaultApiArg = {
    /** BillToModeDefaultVm object for the default mode to add */
    billToModeDefaultVm: BillToModeDefaultVm;
};
export type ModifyBillToModeDefaultApiResponse =
    /** status 200 Success */ BillToModeDefaultVm;
export type ModifyBillToModeDefaultApiArg = {
    /** GUID of the customer mode default to update */
    defaultId: string;
    /** BillToModeDefaultVm object for the default to update */
    billToModeDefaultVm: BillToModeDefaultVm;
};
export type DeleteBillToModeDefaultApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteBillToModeDefaultApiArg = {
    /** ID of the default to remove */
    defaultId: string;
};
export type GetBillToMapsByCarrierApiResponse =
    /** status 200 Success */ CarrBtMapVm[];
export type GetBillToMapsByCarrierApiArg = {
    /** ID of the carrier to load bill-to maps for */
    carrierId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type CreateCarrierBtMapApiResponse =
    /** status 200 Success */ CarrBtMapVm;
export type CreateCarrierBtMapApiArg = {
    /** CarrBtMapVm object for the mapping to add */
    carrBtMapVm: CarrBtMapVm;
};
export type DeleteCarrierBtMapApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCarrierBtMapApiArg = {
    /** Carrier whose mapping to delete */
    carrId: string;
    /** Carrier account for mapping to delete */
    carrAcct: string;
    /** Bill-To ID for mapping to delete */
    btId: string;
};
export type GetCarrierEdiMasterByIdApiResponse =
    /** status 200 Success */ CarrEdiMasterVm[];
export type GetCarrierEdiMasterByIdApiArg = {
    /** ID of the carrier to load EDI info for */
    carrierId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type CreateCarrierEdiMasterApiResponse =
    /** status 200 Success */ CarrEdiMasterVm;
export type CreateCarrierEdiMasterApiArg = {
    /** CarrEdiMasterVm object for the EDI info to add */
    carrEdiMasterVm: CarrEdiMasterVm;
};
export type ModifyCarrierEdiMasterApiResponse =
    /** status 200 Success */ CarrEdiMasterVm;
export type ModifyCarrierEdiMasterApiArg = {
    /** Sender Qualifier for the EDI mapping to update */
    senderQual: string;
    /** Sender ID for the EDI mapping to update */
    senderId: string;
    /** Type of the EDI mapping to update */
    ediType: string;
    /** Receiver Qualifier for the EDI mapping to update */
    rcvQual: string;
    /** Receiver ID for the EDI mapping to update */
    rcvId: string;
    /** CarrEdiMasterVm object for the EDI Master Info to update */
    carrEdiMasterVm: CarrEdiMasterVm;
};
export type DeleteCarrierEdiMasterApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCarrierEdiMasterApiArg = {
    /** Sender Qualifier for the EDI mapping to delete */
    senderQual: string;
    /** Sender ID for the EDI mapping to delete */
    senderId: string;
    /** Type of the EDI mapping to delete */
    ediType: string;
    /** Receiver Qualifier for the EDI mapping to delete */
    rcvQual: string;
    /** Receiver ID for the EDI mapping to delete */
    rcvId: string;
};
export type GetAllCarrierFamiliesApiResponse =
    /** status 200 Success */ CarrFamVm[];
export type GetAllCarrierFamiliesApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type GetCarriersForDropdownApiResponse =
    /** status 200 Success */ CarrierMinimalVm[];
export type GetCarriersForDropdownApiArg = void;
export type GetByScacApiResponse = /** status 200 Success */ CarrierMinimalVm;
export type GetByScacApiArg = {
    scac: string;
};
export type GetCarrierChargeCodeMappingApiResponse =
    /** status 200 Success */ CarrierChargeCodeMappingVm[];
export type GetCarrierChargeCodeMappingApiArg = void;
export type GetCarrierChargeCodeMappingByIdApiResponse =
    /** status 200 Success */ CarrierChargeCodeMappingVm[];
export type GetCarrierChargeCodeMappingByIdApiArg = {
    id: string;
};
export type AddNewCarrierChargeCodeMappingApiResponse =
    /** status 200 Success */ CarrierChargeCodeMappingVm[];
export type AddNewCarrierChargeCodeMappingApiArg = {
    id: string;
    carrierChargeCodeMappingVm: CarrierChargeCodeMappingVm;
};
export type UpdateCarrierChargeCodeMappingApiResponse =
    /** status 200 Success */ CarrierChargeCodeMappingVm[];
export type UpdateCarrierChargeCodeMappingApiArg = {
    id: string;
    carrierChargeCodeMappingVm: CarrierChargeCodeMappingVm;
};
export type DeletCarrierChargeCodeMappingApiResponse =
    /** status 200 Success */ CarrierChargeCodeMappingVm[];
export type DeletCarrierChargeCodeMappingApiArg = {
    id: string;
    carrierChargeCodeMappingVm: CarrierChargeCodeMappingVm;
};
export type GetCarrierChargeCodeMappingOverridesApiResponse =
    /** status 200 Success */ CarrierChargeCodesCustomerModeOverrideVm[];
export type GetCarrierChargeCodeMappingOverridesApiArg = void;
export type GetCarrierChargeCodeMappingOverrideByCarrierIdApiResponse =
    /** status 200 Success */ CarrierChargeCodesCustomerModeOverrideVm[];
export type GetCarrierChargeCodeMappingOverrideByCarrierIdApiArg = {
    id: string;
};
export type AddNewCarrierChargeCodeMappingOverrideApiResponse =
    /** status 200 Success */ CarrierChargeCodesCustomerModeOverrideVm[];
export type AddNewCarrierChargeCodeMappingOverrideApiArg = {
    id: string;
    billto: string;
    carrierChargeCodesCustomerModeOverrideVm: CarrierChargeCodesCustomerModeOverrideVm;
};
export type UpdateCarrierChargeCodeMappingOverrideApiResponse =
    /** status 200 Success */ CarrierChargeCodesCustomerModeOverrideVm;
export type UpdateCarrierChargeCodeMappingOverrideApiArg = {
    id: string;
    billto: string;
    carrierChargeCodesCustomerModeOverrideVm: CarrierChargeCodesCustomerModeOverrideVm;
};
export type DeleteCarrierChargeCodeMappingOverrideApiResponse =
    /** status 200 Success */ CarrierChargeCodesCustomerModeOverrideVm[];
export type DeleteCarrierChargeCodeMappingOverrideApiArg = {
    id: string;
    billto: string;
    carrierChargeCodesCustomerModeOverrideVm: CarrierChargeCodesCustomerModeOverrideVm;
};
export type GetCarrierByIdApiResponse = /** status 200 Success */ CarrierVm;
export type GetCarrierByIdApiArg = {
    /** ID of the carrier to load info on */
    carrierId: string;
};
export type GetAllCarriersApiResponse = /** status 200 Success */ CarrierVm[];
export type GetAllCarriersApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type CreateCarriersApiResponse = /** status 200 Success */ CarrierVm;
export type CreateCarriersApiArg = {
    /** CarrierVm object for the carrier to add */
    carrierVm: CarrierVm;
};
export type ModifyCarriersApiResponse = /** status 200 Success */ CarrierVm;
export type ModifyCarriersApiArg = {
    /** ID of the carrier to update */
    carrierId: string;
    /** CarrierVm object for the carrier to update */
    carrierVm: CarrierVm;
};
export type DeleteCarriersApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCarriersApiArg = {
    /** ID of the carrier to remove */
    carrierId: string;
};
export type ActivateCarriersApiResponse = /** status 200 Success */
    | CarrierVm
    | /** status 204 Deletion completed */ undefined;
export type ActivateCarriersApiArg = {
    /** ID of the carrier to remove */
    carrierId: string;
    /** CarrierActiveVm object for the carrier to update */
    carrierActiveVm: CarrierActiveVm;
};
export type GetAllCarrierContactsApiResponse =
    /** status 200 Success */ CarrierContactVm[];
export type GetAllCarrierContactsApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type CreateCarrierContactsApiResponse =
    /** status 200 Success */ CarrierContactVm;
export type CreateCarrierContactsApiArg = {
    /** CarrierContactVm object for the carrier to add */
    carrierContactVm: CarrierContactVm;
};
export type GetCarrierContactByIdApiResponse =
    /** status 200 Success */ CarrierContactVm[];
export type GetCarrierContactByIdApiArg = {
    /** ID of the carrier to load contacts for */
    carrierId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type ModifyCarrierContactsApiResponse =
    /** status 200 Success */ CarrierContactVm;
export type ModifyCarrierContactsApiArg = {
    /** ID of the carrier contact to update */
    contactId: number;
    /** CarrierContactVm object for the contact to update */
    carrierContactVm: CarrierContactVm;
};
export type DeleteCarrierContactsApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCarrierContactsApiArg = {
    /** ID of the carrier contact to remove */
    contactId: number;
};
export type GetCarrierModeMapsByIdApiResponse =
    /** status 200 Success */ CarrierModeMapVm[];
export type GetCarrierModeMapsByIdApiArg = {
    /** ID of the carrier to load mode mappings for */
    carrierId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type CreateCarrierModeMapsApiResponse =
    /** status 200 Success */ CarrierModeMapVm;
export type CreateCarrierModeMapsApiArg = {
    /** CarrierModeMapVm object for the mapping to add */
    carrierModeMapVm: CarrierModeMapVm;
};
export type ModifyCarrierModeMapsApiResponse =
    /** status 200 Success */ CarrierModeMapVm;
export type ModifyCarrierModeMapsApiArg = {
    /** ID of the carrier mode mapping to update */
    mapId: number;
    /** CarrierModeMapVm object for the mapping to update */
    carrierModeMapVm: CarrierModeMapVm;
};
export type DeleteCarrierModeMapsApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCarrierModeMapsApiArg = {
    /** ID of the carrier mode map to remove */
    mapId: number;
};
export type GetPayMethodsForCarrierApiResponse =
    /** status 200 Success */ CarrierPaymentRemitVm[];
export type GetPayMethodsForCarrierApiArg = {
    /** ID of the carrier to pull payment info for */
    carrierId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type CreateCarrierPayRemitApiResponse =
    /** status 200 Success */ CarrierPaymentRemitVm;
export type CreateCarrierPayRemitApiArg = {
    /** CarrierPaymentRemitVm object for the payment/remit info to add */
    carrierPaymentRemitVm: CarrierPaymentRemitVm;
};
export type ModifyCarrierPayRemitApiResponse =
    /** status 200 Success */ CarrierPaymentRemitVm;
export type ModifyCarrierPayRemitApiArg = {
    /** ID of the payment/remit info entry to update */
    remitInfoId: number;
    /** CarrierPaymentRemitVm object for the Payment/Remit Info to update */
    carrierPaymentRemitVm: CarrierPaymentRemitVm;
};
export type DeleteCarrierPayRemitApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCarrierPayRemitApiArg = {
    /** ID of the payment/remit info entry to delete */
    remitInfoId: number;
};
export type GetCarrierRemitMethodsApiResponse =
    /** status 200 Success */ string[];
export type GetCarrierRemitMethodsApiArg = void;
export type GetCarrierRemitDeliveryMethodsApiResponse =
    /** status 200 Success */ string[];
export type GetCarrierRemitDeliveryMethodsApiArg = void;
export type GetCarrierRemitFormatsApiResponse =
    /** status 200 Success */ string[];
export type GetCarrierRemitFormatsApiArg = void;
export type GetAchSecCodesApiResponse = /** status 200 Success */ string[];
export type GetAchSecCodesApiArg = void;
export type GetCarrierInvoiceByIdApiResponse =
    /** status 200 Success */ CarrInvVm;
export type GetCarrierInvoiceByIdApiArg = {
    id: number;
};
export type GetInvoiceSummaryApiResponse =
    /** status 200 Success */ InvoiceSummaryVm;
export type GetInvoiceSummaryApiArg = {
    id: number;
};
export type GetInvoiceLineSummaryApiResponse =
    /** status 200 Success */ InvoiceSummaryVm;
export type GetInvoiceLineSummaryApiArg = {
    id: number;
};
export type GetInvoiceChargeDetailsApiResponse =
    /** status 200 Success */ LineRcTariffQwMarksVm[];
export type GetInvoiceChargeDetailsApiArg = {
    id: number;
};
export type GetInvoiceLineChargeDetailsApiResponse =
    /** status 200 Success */ LineRcTariffQwMarksVm[];
export type GetInvoiceLineChargeDetailsApiArg = {
    id: number;
};
export type CreateApiResponse = /** status 200 Success */ CarrInvMinimalVm;
export type CreateApiArg = {
    carrInvVm: CarrInvVm;
};
export type InitiateMultiPartInvoiceCreationApiResponse =
    /** status 200 Success */ InitiateMultiPartInvoiceCreationResponse;
export type InitiateMultiPartInvoiceCreationApiArg = {
    initiateMultiPartInvoiceCreationRequest: InitiateMultiPartInvoiceCreationRequest;
};
export type MultiPartInvoiceCreationApiResponse =
    /** status 200 Success */ InvoicePartResponse;
export type MultiPartInvoiceCreationApiArg = {
    invoicePartRequest: InvoicePartRequest;
};
export type CompleteMultiPartInvoiceCreationApiResponse =
    /** status 200 Success */ CompleteMultiPartInvoiceCreationResponse;
export type CompleteMultiPartInvoiceCreationApiArg = {
    completeMultiPartInvoiceCreationRequest: CompleteMultiPartInvoiceCreationRequest;
};
export type AbortMultiPartInvoiceCreationApiResponse = unknown;
export type AbortMultiPartInvoiceCreationApiArg = {
    abortMultiPartInvoiceCreationRequest: AbortMultiPartInvoiceCreationRequest;
};
export type CreateQueuedApiResponse =
    /** status 200 Success */ QueuedInvoiceCreationResponse;
export type CreateQueuedApiArg = {
    carrInvVm: CarrInvVm;
};
export type PostApiCarrInvCheckQueuedInvoiceCreationStateApiResponse =
    /** status 200 Success */ InvoiceCreationStatusResponse;
export type PostApiCarrInvCheckQueuedInvoiceCreationStateApiArg = {
    invoiceCreationStatusRequest: InvoiceCreationStatusRequest;
};
export type ValidateCodingApiResponse = /** status 200 Success */ string;
export type ValidateCodingApiArg = {
    id: number;
    isSave?: boolean;
    isFromApp?: boolean;
};
export type ValidateLineCodingApiResponse = /** status 200 Success */ string;
export type ValidateLineCodingApiArg = {
    id: number;
    lineIdx: number;
    isSave?: boolean;
    isFromApp?: boolean;
};
export type CreateBillingInvoiceApiResponse = /** status 200 Success */
    | CarrInvVm
    | /** status 204 Returns 204 if no billing invoice was created. */ undefined;
export type CreateBillingInvoiceApiArg = {
    id: number;
    handledInvoiceException?: boolean;
    createPdf?: boolean;
    createDupeIfExists?: boolean;
};
export type CreateBillingInvoiceQueuedApiResponse = /** status 200 Success */
    | CarrInvVm
    | /** status 202  */ undefined;
export type CreateBillingInvoiceQueuedApiArg = {
    id: number;
    handledInvoiceException?: boolean;
    createPdf?: boolean;
};
export type CreatePdfInvoiceApiResponse = unknown;
export type CreatePdfInvoiceApiArg = {
    id: number;
};
export type CreatePdfInvoiceQueuedApiResponse = unknown;
export type CreatePdfInvoiceQueuedApiArg = {
    id: number;
};
export type RegeneratePdfInvoiceApiResponse = unknown;
export type RegeneratePdfInvoiceApiArg = {
    id: number;
};
export type GetImagesForInvoiceApiResponse =
    /** status 200 Success */ CarrierInvoiceImagesVm[];
export type GetImagesForInvoiceApiArg = {
    id: number;
};
export type AddImageApiResponse =
    /** status 200 Success */ CarrierInvoiceImagesVm;
export type AddImageApiArg = {
    id: number;
    carrierInvoiceImagesVm: CarrierInvoiceImagesVm;
};
export type ClearCachedImagesForInvoiceApiResponse =
    /** status 200 Success */ CarrierInvoiceImagesVm[];
export type ClearCachedImagesForInvoiceApiArg = {
    id: number;
};
export type GetImageWithDataApiResponse =
    /** status 200 Success */ CarrierInvoiceImagesVm;
export type GetImageWithDataApiArg = {
    id: number;
    imageId: number;
};
export type GetImageWithDataFromObjectApiResponse =
    /** status 200 Success */ CarrierInvoiceImagesVm;
export type GetImageWithDataFromObjectApiArg = {
    id: number;
    imageId: string;
    carrierInvoiceImagesVm: CarrierInvoiceImagesVm;
};
export type CarrInvDisconnectImageApiResponse = unknown;
export type CarrInvDisconnectImageApiArg = {
    id: number;
    imageId: number;
};
export type WhatIfChargeCodesForNewBilltoApiResponse =
    /** status 200 Success */ WhatIfChargeCodeMapVm[];
export type WhatIfChargeCodesForNewBilltoApiArg = {
    id: number;
    newBillToId: string;
};
export type GetAllCarrServicesApiResponse =
    /** status 200 Success */ CarrServicesVm[];
export type GetAllCarrServicesApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type CreateCarrierServicesApiResponse =
    /** status 200 Success */ CarrServicesVm;
export type CreateCarrierServicesApiArg = {
    /** CarrServicesVm object for the service to add */
    carrServicesVm: CarrServicesVm;
};
export type GetCarrierServicesByIdApiResponse =
    /** status 200 Success */ CarrServicesVm[];
export type GetCarrierServicesByIdApiArg = {
    /** ID of the carrier to load services for */
    carrierId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type ModifyCarrierServiceApiResponse =
    /** status 200 Success */ CarrServicesVm;
export type ModifyCarrierServiceApiArg = {
    /** Which carrier to update a code for */
    carrierId: string;
    /** Which code for the carrier to update */
    svcCode: string;
    /** CarrServicesVm object for the service to update */
    carrServicesVm: CarrServicesVm;
};
export type DeleteCarrierServicesApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCarrierServicesApiArg = {
    /** Which carrier to delete a code for */
    carrierId: string;
    /** Which code for the carrier to delete */
    svcCode: string;
};
export type GetAllowedCarrSvcAuditFnsApiResponse =
    /** status 200 Success */ string[];
export type GetAllowedCarrSvcAuditFnsApiArg = void;
export type GetAllCmContractsApiResponse =
    /** status 200 Success */ CmContractVm[];
export type GetAllCmContractsApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type CreateCmContractsApiResponse =
    /** status 200 Success */ CmContractVm;
export type CreateCmContractsApiArg = {
    /** CmContractVm object for the contract to add */
    cmContractVm: CmContractVm;
};
export type ModifyCmContractsApiResponse =
    /** status 200 Success */ CmContractVm;
export type ModifyCmContractsApiArg = {
    /** ID of the carrier used in the contract to update */
    carrier: string;
    /** ID of the customer used in the contract to update */
    customer: string;
    /** Service used in the contract to update */
    service: string;
    /** CmContractVm object for the contract to update */
    cmContractVm: CmContractVm;
};
export type DeleteCmContractsApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCmContractsApiArg = {
    /** ID of the carrier used in the contract to remove */
    carrier: string;
    /** ID of the customer used in the contract to remove */
    customer: string;
    /** Service used in the contract to remove */
    service: string;
};
export type GetAllMasterCodesApiResponse =
    /** status 200 Success */ CodeMasterVm[];
export type GetAllMasterCodesApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type GetMasterCodesForElementApiResponse =
    /** status 200 Success */ CodeMasterVm[];
export type GetMasterCodesForElementApiArg = {
    /** Master Code element to search on */
    element: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type ModifyMasterCodesApiResponse =
    /** status 200 Success */ CodeMasterVm;
export type ModifyMasterCodesApiArg = {
    /** element of the Master Code to update */
    element: string;
    /** code of the Master Code to update */
    code: string;
    /** CodeMasterVm object for the state to update */
    codeMasterVm: CodeMasterVm;
};
export type GetMasterCodeFiltersApiResponse =
    /** status 200 Success */ CodeMasterElements;
export type GetMasterCodeFiltersApiArg = void;
export type GetActiveCurrencyCodesApiResponse =
    /** status 200 Success */ CurrencyVm[];
export type GetActiveCurrencyCodesApiArg = void;
export type GetAuditFailCodesApiResponse =
    /** status 200 Success */ StatusMasterVm[];
export type GetAuditFailCodesApiArg = void;
export type GetCustomerContactsByIdApiResponse =
    /** status 200 Success */ ContactsVm[];
export type GetCustomerContactsByIdApiArg = {
    /** ID of the customer to load contacts for */
    customerId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type CreateCustomerContactsApiResponse =
    /** status 200 Success */ ContactsVm;
export type CreateCustomerContactsApiArg = {
    /** ContactsVm object for the contact to add */
    contactsVm: ContactsVm;
};
export type ModifyCustomerContactsApiResponse =
    /** status 200 Success */ ContactsVm;
export type ModifyCustomerContactsApiArg = {
    /** ID of the customer contact to update */
    contactId: number;
    /** ContactsVm object for the contact to update */
    contactsVm: ContactsVm;
};
export type DeleteCustomerContactsApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCustomerContactsApiArg = {
    /** ID of the customer contact to remove */
    contactId: number;
};
export type GetAllCurrenciesApiResponse =
    /** status 200 Success */ CurrenciesVm[];
export type GetAllCurrenciesApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type GetRefDefsApiResponse =
    /** status 200 Success */ CustomerDataEntryGridVm[];
export type GetRefDefsApiArg = {
    /** ID of the customer to load reference definitions for */
    customerId: string;
    /** ID of the carrier to load reference definitions for */
    carrierId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type CreateRefDefApiResponse =
    /** status 200 Success */ CustomerDataEntryVm;
export type CreateRefDefApiArg = {
    /** CustomerDataEntryVm object for the reference definition to add */
    customerDataEntryVm: CustomerDataEntryVm;
};
export type ModifyRefDefApiResponse =
    /** status 200 Success */ CustomerDataEntryVm;
export type ModifyRefDefApiArg = {
    /** ID of the reference definition to update */
    defId: number;
    /** CustomerDataEntryVm object for the reference definition to update */
    customerDataEntryVm: CustomerDataEntryVm;
};
export type DeleteRefDefApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteRefDefApiArg = {
    /** ID of the definition to remove */
    defId: number;
};
export type CreateReceivableBatchesForCustomersApiResponse = unknown;
export type CreateReceivableBatchesForCustomersApiArg = {
    createReceivableBatchesForCustomersVm: CreateReceivableBatchesForCustomersVm;
};
export type CreateReceivableBatchesFromInvoicesApiResponse =
    /** status 200 Success */ ReceivableBatchResultVm[];
export type CreateReceivableBatchesFromInvoicesApiArg = {
    body: number[];
};
export type GetListApiResponse = /** status 200 Success */ CustPaySetupVm[];
export type GetListApiArg = void;
export type UpsertApiResponse = /** status 200 Success */ CustPaySetupVm;
export type UpsertApiArg = {
    custPaySetupVm: CustPaySetupVm;
};
export type GetCustPayByBillToIdByIdApiResponse =
    /** status 200 Success */ CustPaySetupVm[];
export type GetCustPayByBillToIdByIdApiArg = {
    id: string;
};
export type GetCustPaySetupByIdApiResponse =
    /** status 200 Success */ CustPaySetupVm[];
export type GetCustPaySetupByIdApiArg = {
    /** ID of the customer to load pay setup for */
    customerId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type CreateCustPaySetupApiResponse =
    /** status 200 Success */ CustPaySetupVm;
export type CreateCustPaySetupApiArg = {
    /** ID of the customer to add pay setup to */
    customerId: string;
    /** CustPaySetupVm object for the setup to add */
    custPaySetupVm: CustPaySetupVm;
};
export type ModifyCustPaySetupApiResponse =
    /** status 200 Success */ CustPaySetupVm;
export type ModifyCustPaySetupApiArg = {
    /** ID of the customer pay setup to update */
    setupId: number;
    /** CustPaySetupVm object for the setup to update */
    custPaySetupVm: CustPaySetupVm;
};
export type DeleteCustPaySetupApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCustPaySetupApiArg = {
    /** ID of the customer pay setup to remove */
    setupId: number;
};
export type GetShipmentCountByStatusApiResponse =
    /** status 200 Success */ ShipmentCountByStatusVm[];
export type GetShipmentCountByStatusApiArg = void;
export type GetAgedInvoiceSummaryApiResponse =
    /** status 200 Success */ AgedInvoiceSummaryVm[];
export type GetAgedInvoiceSummaryApiArg = void;
export type GetDataEntryAdminInfoByCustomerApiResponse =
    /** status 200 Success */ DeAdminVm[];
export type GetDataEntryAdminInfoByCustomerApiArg = {
    /** ID of the customer to load data entry admin info for */
    customerId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type CreateDataEntryAdminInfoApiResponse =
    /** status 200 Success */ DeAdminVm;
export type CreateDataEntryAdminInfoApiArg = {
    /** DEAdminVm object for the admin info to add */
    deAdminVm: DeAdminVm;
};
export type ModifyDataEntryAdminInfoApiResponse =
    /** status 200 Success */ DeAdminVm;
export type ModifyDataEntryAdminInfoApiArg = {
    /** ID of the customer whose DE Admin info to update */
    customerId: string;
    /** ID of the carrier whose DE Admin info to update */
    carrierId: string;
    /** DEAdminVm object for the admin info to update */
    deAdminVm: DeAdminVm;
};
export type DeleteDataEntryAdminInfoApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteDataEntryAdminInfoApiArg = {
    /** ID of the customer whose DE Admin info to delete */
    customerId: string;
    /** ID of the carrier whose DE Admin info to delete */
    carrierId: string;
};
export type InvoiceResearchExportApiResponse =
    /** status 200 Success */ DataExportsVm[];
export type InvoiceResearchExportApiArg = {
    userJobName?: string;
    fileFormat?: ExportFileFormat;
    invoiceResearchOptionsVm: InvoiceResearchOptionsVm;
};
export type GetDataExportsApiResponse =
    /** status 200 Success */ DataExportsVm[];
export type GetDataExportsApiArg = void;
export type DeleteExportApiResponse = /** status 200 Success */ DataExportsVm[];
export type DeleteExportApiArg = {
    id: number;
};
export type SendMailWithOutAttachmentsApiResponse = unknown;
export type SendMailWithOutAttachmentsApiArg = {
    emailVm: EmailVm;
};
export type BulkCodingApiResponse = unknown;
export type BulkCodingApiArg = {
    glBulkCodingRequest: GlBulkCodingRequest;
};
export type GetGlCodeForInvoiceApiResponse = unknown;
export type GetGlCodeForInvoiceApiArg = {
    glCodingRequest: GlCodingRequest;
};
export type PostHopkinsDepartmentApiResponse = unknown;
export type PostHopkinsDepartmentApiArg = {
    hopkinsDepartmentVm: HopkinsDepartmentVm;
};
export type GetHealthCheckApiResponse = unknown;
export type GetHealthCheckApiArg = void;
export type GetApiResponse = unknown;
export type GetApiArg = void;
export type GetImageApiResponse =
    /** status 200 Success */ CarrierInvoiceImagesVm;
export type GetImageApiArg = {
    imageId: number;
};
export type DeleteImageApiResponse = unknown;
export type DeleteImageApiArg = {
    imageId: number;
};
export type DisconnectImageApiResponse = unknown;
export type DisconnectImageApiArg = {
    imageId: number;
};
export type GetDisconnectedImagesApiResponse =
    /** status 200 Success */ DisconnectedCarrInvImagesVm[];
export type GetDisconnectedImagesApiArg = void;
export type UploadDisconnectedImageApiResponse = unknown;
export type UploadDisconnectedImageApiArg = {
    carrierInvoiceImagesVm: CarrierInvoiceImagesVm;
};
export type ReleaseInvoiceApiResponse = unknown;
export type ReleaseInvoiceApiArg = {
    type: string;
    id: number;
};
export type GetBasicInvInfoApiResponse =
    /** status 200 Success */ BasicInfoVmGetResponse;
export type GetBasicInvInfoApiArg = {
    type: string;
    id: number;
};
export type GetDetailedChargesApiResponse =
    /** status 200 Success */ DetailedChargeListVm;
export type GetDetailedChargesApiArg = {
    type: InvType;
    id: number;
};
export type GetReferencesApiResponse =
    /** status 200 Success */ ReferenceListVm;
export type GetReferencesApiArg = {
    type: string;
    id: number;
};
export type UpdateReferencesApiResponse =
    /** status 200 Success */ ReferenceListVm;
export type UpdateReferencesApiArg = {
    type: string;
    id: number;
    referenceListVm: ReferenceListVm;
};
export type GetImagesApiResponse = /** status 200 Success */ ImageListVm;
export type GetImagesApiArg = {
    type: string;
    id: number;
};
export type UpdateCommentApiResponse = /** status 200 Success */ InvoiceComment;
export type UpdateCommentApiArg = {
    type: string;
    id: number;
    invoiceComment: InvoiceComment;
};
export type GetInvoiceResearchPopulationDataApiResponse =
    /** status 200 Success */ InvoiceResearchOptionsVm;
export type GetInvoiceResearchPopulationDataApiArg = void;
export type SearchInvoicesApiResponse =
    /** status 200 Success */ CarrInvMinimalVm[];
export type SearchInvoicesApiArg = {
    invoiceResearchOptionsVm: InvoiceResearchOptionsVm;
};
export type ReactDataTableServerSideProcessingApiResponse =
    /** status 200 Success */ InvoiceResearchListVmPagingResponse;
export type ReactDataTableServerSideProcessingApiArg = {
    invoiceResearchOptionsVm: InvoiceResearchOptionsVm;
};
export type GetMakeRealWorkaroundInvoicesApiResponse =
    /** status 200 Success */ MakeRealVm[];
export type GetMakeRealWorkaroundInvoicesApiArg = void;
export type PostMakeRealWorkaroundInvoicesApiResponse =
    /** status 200 Success */ MakeRealVm[];
export type PostMakeRealWorkaroundInvoicesApiArg = void;
export type GetStatusesForExceptionsApiResponse =
    /** status 200 Success */ string[];
export type GetStatusesForExceptionsApiArg = void;
export type GetExceptionsForGridApiResponse =
    /** status 200 Success */ ExceptionManagerListVm[];
export type GetExceptionsForGridApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type SaveCurrentRemarksApiResponse = /** status 200 Success */ boolean;
export type SaveCurrentRemarksApiArg = {
    /** Invoices to add an audit comment and the comment */
    exceptionManagerActionVm: ExceptionManagerActionVm;
};
export type AcceptAsEnteredApiResponse = /** status 200 Success */ boolean;
export type AcceptAsEnteredApiArg = {
    /** Invoices to accept and an audit comment */
    exceptionManagerActionVm: ExceptionManagerActionVm;
};
export type AcceptAsAuditedApiResponse = /** status 200 Success */ boolean;
export type AcceptAsAuditedApiArg = {
    /** Invoices to accept and an audit comment */
    exceptionManagerActionVm: ExceptionManagerActionVm;
};
export type AcceptAsAdjustedApiResponse = /** status 200 Success */ boolean;
export type AcceptAsAdjustedApiArg = {
    /** Invoices to adjust/accept and an audit comment */
    exceptionManagerAcceptAsAdjustedVm: ExceptionManagerAcceptAsAdjustedVm;
};
export type RefuseInvoiceApiResponse = /** status 200 Success */ boolean;
export type RefuseInvoiceApiArg = {
    /** Invoices to refuse and an audit comment */
    exceptionManagerActionVm: ExceptionManagerActionVm;
};
export type ExceptionManagerDeleteApiResponse =
    /** status 200 Success */ boolean;
export type ExceptionManagerDeleteApiArg = {
    /** Invoices to delete and an audit comment */
    exceptionManagerActionVm: ExceptionManagerActionVm;
};
export type GetAvailableAuditFailStatusesApiResponse =
    /** status 200 Success */ StatusMasterVm[];
export type GetAvailableAuditFailStatusesApiArg = void;
export type GetCarrierChargeCodeSourcesApiResponse =
    /** status 200 Success */ CarrierChargeCodeSourceGenericDropDownStruct[];
export type GetCarrierChargeCodeSourcesApiArg = void;
export type GetCustomerDataEntryCodesForUserApiResponse =
    /** status 200 Success */ CustomerReferenceCodeVm[];
export type GetCustomerDataEntryCodesForUserApiArg = void;
export type GetCustomerDataEntryCodesApiResponse =
    /** status 200 Success */ CustomerReferenceCodeVm[];
export type GetCustomerDataEntryCodesApiArg = {
    billToId: string;
};
export type GetIa360ReportingLinkApiResponse = /** status 200 Success */ string;
export type GetIa360ReportingLinkApiArg = {
    carrierId?: string;
    invoiceNum?: string;
};
export type GetInvoiceStatusCodesApiResponse =
    /** status 200 Success */ StatusCodeVm[];
export type GetInvoiceStatusCodesApiArg = void;
export type GetEntryMethodsApiResponse =
    /** status 200 Success */ EntryMethodVm[];
export type GetEntryMethodsApiArg = void;
export type GetActivityCodesApiResponse =
    /** status 200 Success */ CodeMasterVm[];
export type GetActivityCodesApiArg = void;
export type GetAscRefCodesApiResponse =
    /** status 200 Success */ AscReferenceCodeVm[];
export type GetAscRefCodesApiArg = void;
export type GetAscChargeCodesApiResponse =
    /** status 200 Success */ AscChargeCodeVm[];
export type GetAscChargeCodesApiArg = {
    sorted?: boolean;
};
export type GetTransportModesApiResponse = /** status 200 Success */ ModeVm[];
export type GetTransportModesApiArg = void;
export type GetInvoiceTypeListApiResponse = /** status 200 Success */ string[];
export type GetInvoiceTypeListApiArg = void;
export type GetCarrierPayableExceptionsByIdApiResponse =
    /** status 200 Success */ PayablesExceptionsVm[];
export type GetCarrierPayableExceptionsByIdApiArg = {
    /** ID of the carrier to load exceptions for */
    carrierId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type CreateCarrierPayExceptionApiResponse =
    /** status 200 Success */ PayablesExceptionsVm;
export type CreateCarrierPayExceptionApiArg = {
    /** PayablesExceptionsVm object for the exception to add */
    payablesExceptionsVm: PayablesExceptionsVm;
};
export type ModifyCarrierPayExceptionApiResponse =
    /** status 200 Success */ PayablesExceptionsVm;
export type ModifyCarrierPayExceptionApiArg = {
    /** ID of the carrier contact to update */
    exceptionId: number;
    /** PayablesExceptionsVm object for the exception to update */
    payablesExceptionsVm: PayablesExceptionsVm;
};
export type DeleteCarrierPayExceptionApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteCarrierPayExceptionApiArg = {
    /** ID of the carrier payable exception to remove */
    exceptionId: number;
};
export type GetAllPayDayStartsApiResponse =
    /** status 200 Success */ PayDaysStartVm[];
export type GetAllPayDayStartsApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type GetPermittedValsByCustomerApiResponse =
    /** status 200 Success */ PermittedValuesVm[];
export type GetPermittedValsByCustomerApiArg = {
    /** ID of the customer to load permitted value info for */
    customerId: string;
    /** ID of the carrier to load permitted value info for */
    carrierId: string;
    /** ASC Ref Code to load permitted value info for */
    code: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type CreatePermittedValueApiResponse =
    /** status 200 Success */ PermittedValuesVm;
export type CreatePermittedValueApiArg = {
    /** PermittedValuesVm object for the permitted value to add */
    permittedValuesVm: PermittedValuesVm;
};
export type ModifyPermittedValueApiResponse =
    /** status 200 Success */ PermittedValuesVm;
export type ModifyPermittedValueApiArg = {
    /** ID of the permitted value to update */
    valId: number;
    /** PermittedValuesVm object for the permitted value to update */
    permittedValuesVm: PermittedValuesVm;
};
export type DeletePermittedValueApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeletePermittedValueApiArg = {
    /** ID of the value to remove */
    valId: number;
};
export type GetPostalCodesApiResponse =
    /** status 200 Success */ PostalCodeVm[];
export type GetPostalCodesApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type CreatePostalCodeApiResponse = unknown;
export type CreatePostalCodeApiArg = {
    /** PostalCodeVm object for the postal code to add */
    postalCodeVm: PostalCodeVm;
};
export type ModifyPostalCodeApiResponse =
    /** status 200 Success */ PostalCodeVm;
export type ModifyPostalCodeApiArg = {
    /** ID of the postal code to update */
    codeId: number;
    /** PostalCodeVm object for the postal code to update */
    postalCodeVm: PostalCodeVm;
};
export type DeletePostalCodeApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeletePostalCodeApiArg = {
    /** ID of the postal code to remove */
    codeId: number;
};
export type GetStatesApiResponse = /** status 200 Success */ StatesVm[];
export type GetStatesApiArg = {
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type CreateStatesApiResponse = /** status 200 Success */ StatesVm;
export type CreateStatesApiArg = {
    /** StatesVm object for the state to add */
    statesVm: StatesVm;
};
export type ModifyStatesApiResponse = /** status 200 Success */ StatesVm;
export type ModifyStatesApiArg = {
    /** ID of the state to update */
    stateId: number;
    /** StatesVm object for the state to update */
    statesVm: StatesVm;
};
export type DeleteStatesApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteStatesApiArg = {
    /** ID of the state to remove */
    stateId: number;
};
export type GetTimecardForUserIdApiResponse =
    /** status 200 Success */ UserTimeCardVm;
export type GetTimecardForUserIdApiArg = {
    userId?: string;
    date?: string;
};
export type AddTimeCardApiResponse = unknown;
export type AddTimeCardApiArg = {
    userTimeCardVm: UserTimeCardVm;
};
export type DeleteTimeCardApiResponse = unknown;
export type DeleteTimeCardApiArg = {
    id: string;
};
export type GetUserBillToInfoByCustomerApiResponse =
    /** status 200 Success */ UserVm[];
export type GetUserBillToInfoByCustomerApiArg = {
    /** ID of the customer to load linked user info for */
    customerId: string;
    /** The max number of records. */
    $top?: any;
    /** The number of records to skip. */
    $skip?: any;
    /** A function that must evaluate to true for a record to be returned. */
    $filter?: any;
    /** Determines what values are used to order a collection of records. */
    $orderby?: any;
    /** Use to add related query data. */
    $expand?: any;
};
export type CreateUserBillToInfoApiResponse =
    /** status 200 Success */ UserBillToVm;
export type CreateUserBillToInfoApiArg = {
    /** UserBillToVm object for the customer/user link to add */
    userBillToVm: UserBillToVm;
};
export type DeleteUserBillToInfoApiResponse =
    /** status 204 Deletion completed */ undefined;
export type DeleteUserBillToInfoApiArg = {
    /** ID of the customer to remove the user from */
    customerId: string;
    /** ID of the user to unlink from the customer */
    userId: string;
};
export type GetMyConfigApiResponse =
    /** status 200 Success */ UserConfigurationVm;
export type GetMyConfigApiArg = void;
export type SaveMyConfigApiResponse =
    /** status 200 Success */ UserConfigurationVm;
export type SaveMyConfigApiArg = {
    userConfigurationVm: UserConfigurationVm;
};
export type GetUserConfigurationApiResponse =
    /** status 200 Success */ UserConfigurationVm;
export type GetUserConfigurationApiArg = {
    userId: string;
};
export type SaveUserConfigApiResponse =
    /** status 200 Success */ UserConfigurationVm;
export type SaveUserConfigApiArg = {
    userId: string;
    userConfigurationVm: UserConfigurationVm;
};
export type GetAllUsersApiResponse = /** status 200 Success */ UserVm[];
export type GetAllUsersApiArg = void;
export type GetTimeCardUsersApiResponse = /** status 200 Success */ UserVm[];
export type GetTimeCardUsersApiArg = void;
export type GetUserSessionsForUserApiResponse =
    /** status 200 Success */ UserSessionsVm[];
export type GetUserSessionsForUserApiArg = {
    userId: string;
    lastWorkDay?: string;
};
export type GetMyUserSessionsApiResponse =
    /** status 200 Success */ UserSessionsVm[];
export type GetMyUserSessionsApiArg = {
    lastWorkDay?: string;
};
export type GetCarrInvStatsForUserApiResponse =
    /** status 200 Success */ CarrInvUserStatsVm[];
export type GetCarrInvStatsForUserApiArg = {
    userId: string;
    lastWorkDay?: string;
};
export type GetMyCarrInvStatsApiResponse =
    /** status 200 Success */ CarrInvUserStatsVm[];
export type GetMyCarrInvStatsApiArg = {
    lastWorkDay?: string;
};
export type AppDefaultVm = {
    parmID: string;
    parmGroup: string;
    parmDescrip?: string | null;
    parmValue?: string | null;
    longValue?: string | null;
};
export type BillToMinimalVm = {
    btId: string;
    name?: string | null;
    customerId?: string | null;
    customerName?: string | null;
    sfremail?: string | null;
    isParent?: boolean;
    address1?: string | null;
    city?: string | null;
    stateProv?: string | null;
    postal?: string | null;
    phone1Num?: string | null;
    phones?: string | null;
};
export type CurrencyVm = {
    code?: string | null;
    display?: string | null;
};
export type DateTimeDropdown = {
    value?: string | null;
    display?: string | null;
};
export type InvoiceApprovalOptionsVm = {
    billTos?: BillToMinimalVm[] | null;
    currencies?: CurrencyVm[] | null;
    batchDate?: DateTimeDropdown[] | null;
    selectedBillTo?: BillToMinimalVm;
    selectedCurrency?: CurrencyVm;
    selectedBatchDate?: DateTimeDropdown;
    onlyPendingFundsRequests?: boolean | null;
};
export type ApproveInvoicesCarrInvLineVm = {
    airBillApprNetDue?: number;
    airBillAuditNetDue?: number;
    airBillSavings?: number | null;
    airBillComment?: string | null;
    airBillMode?: string | null;
    airBillNetDue?: number;
    airBillNum?: string | null;
    airBillRev?: number;
    airBillSelected?: boolean;
    airBillStatus?: string | null;
    currency?: string | null;
    lineIdx?: number;
    lineSeq?: number;
    service?: string | null;
    modified?: boolean;
};
export type ApproveInvoicesInvoiceVm = {
    invIdx?: number;
    invMode?: string | null;
    invoiceApprNetDue?: number | null;
    invoiceAuditNetDue?: number | null;
    invoiceSavings?: number | null;
    invoiceComment?: string | null;
    currency?: string | null;
    invoiceDate?: string | null;
    invoiceNetDue?: number | null;
    invoiceNum?: string | null;
    selected?: boolean;
    invRev?: number;
    invStatus?: string | null;
    invType?: string | null;
    isaSenderId?: string | null;
    airBills?: ApproveInvoicesCarrInvLineVm[] | null;
    modified?: boolean;
};
export type ApproveInvoicesCarrierVm = {
    carrierApprNetDue?: number | null;
    carrierAuditNetDue?: number | null;
    carrierSavings?: number | null;
    carrierId?: string | null;
    selected?: boolean;
    carrierName?: string | null;
    carrierNetDue?: number | null;
    currency?: string | null;
    comment?: string | null;
    invoiceCount?: number;
    invoices?: ApproveInvoicesInvoiceVm[] | null;
};
export type ApproveInvoicesCustomerVm = {
    btId?: string | null;
    masterBtId?: string | null;
    btName?: string | null;
    rcvBatchId?: number;
    rcvBatchDate?: string;
    customerInvoiceNetDue?: number | null;
    customerSavings?: number | null;
    customerInvoiceAuditNetDue?: number | null;
    customerInvoiceApprNetDue?: number | null;
    comment?: string | null;
    currency?: string | null;
    selected?: boolean;
    carrInvoices?: ApproveInvoicesCarrierVm[] | null;
    invoiceCount?: number;
    processingApprovedBatch?: boolean;
};
export type ApproveInvoicesSearchResponse = {
    invoices?: ApproveInvoicesCustomerVm[] | null;
    showApprove?: boolean;
};
export type CarrierMinimalVm = {
    carrId: string;
    name?: string | null;
    scac?: string | null;
    tracingUrl?: string | null;
    defaultInvType?: string | null;
    address1?: string | null;
    city?: string | null;
    stateProv?: string | null;
    postal?: string | null;
    phones?: string | null;
    faxnums?: string | null;
};
export type PartyVm = {
    btId?: string | null;
    carrierId?: string | null;
    name?: string | null;
    name2?: string | null;
    name3?: string | null;
    partyType?: string | null;
    addr1?: string | null;
    addr2?: string | null;
    addr3?: string | null;
    addr4?: string | null;
    city?: string | null;
    stateProv?: string | null;
    postalCode?: string | null;
    countryCode?: string | null;
    countrySub?: string | null;
    fpsCustId?: string | null;
};
export type CarrInvLineRcVm = {
    advances?: number | null;
    approvedAmt?: number | null;
    auditedAmt?: number | null;
    auditMsg?: string | null;
    billedQty?: number | null;
    billedQtyQual?: string | null;
    bolamt?: number | null;
    bolauditedAmt?: number | null;
    carrierId?: string | null;
    charge?: number | null;
    chgMethPay?: string | null;
    currencyCode?: string | null;
    declaredValue?: number | null;
    declValQual?: string | null;
    entitleCode?: string | null;
    freightRate?: number | null;
    invIdx?: number | null;
    invoiceNum?: string | null;
    invRev?: number;
    ladingLine?: number;
    ladingVal?: number | null;
    ladLiabCode?: string | null;
    lineIdx?: number | null;
    lineSeq?: number;
    originalChargeCode?: string | null;
    originalChargeDescr?: string | null;
    originAmt?: number | null;
    paidAmt?: number | null;
    pct?: number | null;
    prepaidAmt?: number | null;
    rateClassCode?: string | null;
    rateCombPointCode?: string | null;
    rateQual?: string | null;
    rcSeq?: number;
    recType?: string | null;
    specChargeCode?: string | null;
    specChgDescr?: string | null;
    tariffAppCode?: string | null;
    totalsColumn?: string | null;
};
export type CarrInvLineTariffVm = {
    agencyCode?: string | null;
    carrierId?: string | null;
    carrSvcLevCode?: string | null;
    cityName?: string | null;
    commodCode?: string | null;
    custSvcLevCode?: string | null;
    distQual?: string | null;
    dscode?: string | null;
    effectiveDate?: string | null;
    exParte?: string | null;
    exParteDate?: string | null;
    freightClass?: string | null;
    intDomCode?: string | null;
    invIdx?: number | null;
    invoiceNum?: string | null;
    invRev?: number;
    ladingLine?: number;
    lineIdx?: number | null;
    lineSeq?: number;
    rateBasisNum?: string | null;
    recType?: string | null;
    scale?: string | null;
    shipMop?: string | null;
    stateProv?: string | null;
    tariffCol?: string | null;
    tariffDist?: number | null;
    tariffItem?: string | null;
    tariffNum?: string | null;
    tariffPart?: number | null;
    tariffSection?: string | null;
    tariffSeq?: number;
    tariffSuppId?: string | null;
};
export type CarrInvLineQwVm = {
    billAsQty?: number | null;
    billAsQual?: string | null;
    carrierId?: string | null;
    dunnageDescr?: string | null;
    invIdx?: number | null;
    invoiceNum?: string | null;
    invRev?: number;
    ladingLine?: number;
    ladingQuant?: number | null;
    lineIdx?: number | null;
    lineSeq?: number;
    pkgFormCode?: string | null;
    pkgFormCode2?: string | null;
    quantity?: number | null;
    qwSeq?: number;
    recType?: string | null;
    svcTypeCode?: string | null;
    volQual?: string | null;
    volume?: number | null;
    weight?: number | null;
    wgtQual?: string | null;
    wgtUnitCode?: string | null;
    wtKilos?: number | null;
    wtPounds?: number | null;
    wtTons?: number | null;
    yesNoCode?: string | null;
};
export type CarrInvLineMarksVm = {
    carrierId?: string | null;
    commCode?: string | null;
    commCode2?: string | null;
    commCodeQual?: string | null;
    commCodeQual2?: string | null;
    compartIdcode?: string | null;
    descrip?: string | null;
    idx?: number;
    invIdx?: number | null;
    invoiceNum?: string | null;
    invRev?: number;
    ladingLine?: number;
    lineIdx?: number | null;
    lineSeq?: number;
    marks?: string | null;
    marksQual?: string | null;
    marksSeq?: number;
    pkgCode?: string | null;
    recType?: string | null;
};
export type LineRcTariffQwMarksVm = {
    lineIndex?: number;
    empty?: boolean;
    rcVm?: CarrInvLineRcVm;
    tariffVm?: CarrInvLineTariffVm;
    qwVm?: CarrInvLineQwVm;
    marksVm?: CarrInvLineMarksVm;
};
export type InvoiceSummaryVm = {
    invoiceNum?: string | null;
    airBillNum?: string | null;
    invType?: string | null;
    carrier?: CarrierMinimalVm;
    shippedDate?: string | null;
    deliveredDate?: string | null;
    shipper?: PartyVm;
    consignee?: PartyVm;
    chargeDetails?: LineRcTariffQwMarksVm[] | null;
};
export type ApproveInvoicesRequestVm = {
    searchOptions?: InvoiceApprovalOptionsVm;
    invoices?: ApproveInvoicesCustomerVm[] | null;
};
export type AscChargeCodeVm = {
    code: string;
    description: string;
    inUse: string;
    cmCode?: string | null;
    dbSign: number;
    totalsColumn: string;
    shortDescription: string;
    backRef?: boolean | null;
};
export type ProblemDetails = {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    [key: string]: any;
};
export type InvoiceChargeTypeVm = {
    id?: number;
    name?: string | null;
    description?: string | null;
};
export type AscReferenceCodeVm = {
    code: string;
    description: string;
    inUse: string;
};
export type AuditMilesRequestVm = {
    originZip?: string | null;
    originCountryCode?: string | null;
    destinationZip?: string | null;
    destinationCountryCode?: string | null;
};
export type LoginVm = {
    userName?: string | null;
    password?: string | null;
};
export type ScreenSize = 'sm' | 'md' | 'lg' | 'xl';
export type CustomerReferenceCodeVm = {
    sortable?: boolean;
    id?: number;
    customerDescription?: string | null;
    displayOrder?: number;
    name?: string | null;
    hide?: ScreenSize;
    code: string;
    description: string;
    inUse: string;
};
export type UserConfigurationVm = {
    invoiceResearchCustomColumns?: CustomerReferenceCodeVm[] | null;
};
export type UserPermissionVm = {
    functionId?: string | null;
    viewOk?: boolean;
    addOk?: boolean;
    editOk?: boolean;
    deleteOk?: boolean;
    exportOk?: boolean;
    logging?: boolean;
};
export type UserVm = {
    userID?: string | null;
    lastName?: string | null;
    firstName?: string | null;
    displayName?: string | null;
    company?: string | null;
    email?: string | null;
    userConfiguration?: UserConfigurationVm;
    allowedBillToIds?: string[] | null;
    allowedCarrierIds?: string[] | null;
    permissions?: UserPermissionVm[] | null;
};
export type LoginResponseVm = {
    jwt?: string | null;
    user?: UserVm;
};
export type BankAccountVm = {
    id: number;
    bankName?: string | null;
    acctNum?: string | null;
    nickName?: string | null;
    gpCheckbook?: string | null;
    cashAcctGL?: string | null;
    disbAcctGL?: string | null;
    isDeposAcct?: number;
    isDisbursAcct?: number;
    purpose?: string | null;
    currency?: string | null;
    lastCheckNum?: number;
    checkTemplate?: string | null;
    dateFormat?: string | null;
    checkNumFmt?: string | null;
    displayName?: string | null;
};
export type BillToVm = {
    active?: string | null;
    actualBtid?: string | null;
    address1?: string | null;
    address2?: string | null;
    auditChargeStatus?: string | null;
    auditClassStatus?: string | null;
    auditMaxCharge?: number;
    auditMaxClass?: string | null;
    auditVarAllow?: number | null;
    auditVarStatus?: string | null;
    autoWithdraw?: string | null;
    btId: string;
    city?: string | null;
    cmCustId?: number | null;
    comDataCustId?: string | null;
    comments?: string | null;
    contactEmail?: string | null;
    contactName?: string | null;
    countryCode?: string | null;
    createdBy?: string | null;
    createdDate?: string | null;
    customerId?: string | null;
    parentName?: string | null;
    defaultPayDays?: number | null;
    defaultPayDaysStart?: number | null;
    defCarrSvc?: string | null;
    emailFeeInvoice?: boolean | null;
    enableIaCustReview?: boolean;
    enableMatchPayAccessorial?: boolean;
    enableMatchPayLiability?: boolean;
    enableMatchPayWeight?: boolean;
    fbogl?: string | null;
    feesRptBtid?: string | null;
    fundsOffsetDays?: number | null;
    glcodingFunction?: string | null;
    importFeeInvoice?: boolean | null;
    isParent?: boolean;
    lastUsed?: string | null;
    makeRecFri?: boolean;
    makeRecMon?: boolean;
    makeRecSat?: boolean;
    makeRecSun?: boolean;
    makeRecThu?: boolean;
    makeRecTue?: boolean;
    makeRecWed?: boolean;
    matchPayProgram?: string | null;
    matchPayWeightFreightClassVariance?: number;
    matchPayWeightTotalVariance?: number;
    matchTable?: string | null;
    milesRequired?: boolean | null;
    name: string;
    phone1Num?: string | null;
    postal?: string | null;
    printFeeInvoice?: boolean | null;
    ratingCode?: string | null;
    sfremail?: string | null;
    stateProv?: string | null;
    synchCibi?: boolean | null;
    tandCdate?: string | null;
    updatedBy?: string | null;
    updatedDate?: string | null;
    useBenchmarking?: boolean | null;
    useCm?: string | null;
    usePayToTerms?: boolean | null;
    useInvoice?: string | null;
    useSfr?: string | null;
    activationStatusChangedBy?: string | null;
    activationStatusChangeDate?: string | null;
    activationStatusChangeReason?: string | null;
};
export type CustomerDataEntryVm = {
    id: number;
    btid: string;
    carrierId: string;
    ascrefCode: string;
    dispOrder?: number;
    customerDescription?: string | null;
    allowMulti?: string | null;
    requiredFieldIndicator?: string | null;
    detailLocation?: string | null;
    fieldFormat?: string | null;
    validationTechnique?: string | null;
    tipText?: string | null;
};
export type BillToActiveVm = {
    btId: string;
    active: number;
    activationStatusChangedBy?: string | null;
    activationStatusChangeDate?: string | null;
    activationStatusChangeReason: string;
};
export type BillToModeDefaultVm = {
    id?: string | null;
    btid: string;
    carrierId?: string | null;
    carrierName?: string | null;
    mode: string;
    netDueDays: number;
    netDueStart: number;
};
export type CarrBtMapVm = {
    carrierId: string;
    carrAcct: string;
    btId: string;
    btName?: string | null;
    fpsCustId?: string | null;
    isProduction?: boolean | null;
};
export type CarrEdiMasterVm = {
    ediSenderQual: string;
    ediSenderId: string;
    ediXactType: string;
    ediRcvQual: string;
    ediRcvId: string;
    carrierId: string;
    fpsCarrId?: string | null;
    useC2?: string | null;
    send820?: string | null;
    procFps?: string | null;
};
export type CarrFamVm = {
    carrierFam: string;
    description?: string | null;
};
export type CarrierChargeCodeSource = 'L108' | 'L112' | 'Ia';
export type CarrierChargeCodeMappingVm = {
    carrierId: string;
    description?: string | null;
    id?: number;
    carrier?: CarrierMinimalVm;
    carrierName?: string | null;
    originalChargeCode: string;
    source: CarrierChargeCodeSource;
    mappedChargeCode: string;
    mappedCode?: AscChargeCodeVm;
    codeDescription?: string | null;
    totalsColumn?: string | null;
    dbSign?: number | null;
    cmCode?: string | null;
};
export type CarrierChargeCodesCustomerModeOverrideVm = {
    billToId: string;
    mode?: string | null;
    reason?: string | null;
    carrierId: string;
    description?: string | null;
    id?: number;
    carrier?: CarrierMinimalVm;
    carrierName?: string | null;
    originalChargeCode: string;
    source: CarrierChargeCodeSource;
    mappedChargeCode: string;
    mappedCode?: AscChargeCodeVm;
    codeDescription?: string | null;
    totalsColumn?: string | null;
    dbSign?: number | null;
    cmCode?: string | null;
};
export type CarrierVm = {
    carrId: string;
    active?: string | null;
    name: string;
    scac?: string | null;
    address1?: string | null;
    address2?: string | null;
    address3?: string | null;
    city?: string | null;
    stateProv?: string | null;
    postal?: string | null;
    countryCode?: string | null;
    phones?: string | null;
    emails?: string | null;
    faxnums?: string | null;
    defaultMode?: string | null;
    fpscarrId?: string | null;
    defaultInvType?: string | null;
    useFor?: string | null;
    lastUsed?: string | null;
    createdDate?: string | null;
    createdBy?: string | null;
    updatedDate?: string | null;
    updatedBy?: string | null;
    family?: string | null;
    payableGl?: string | null;
    inftpsite?: string | null;
    inftpcontacts?: string | null;
    inftpUserId?: string | null;
    inFtppassword?: string | null;
    outFtpsite?: string | null;
    outFtpcontacts?: string | null;
    outFtpuserId?: string | null;
    outFtppassword?: string | null;
    tracingUrl?: string | null;
    allowDupAb?: boolean;
    checkService?: boolean;
    defSvcFn?: string | null;
    disputeEmail?: string | null;
    imagingId?: string | null;
    activationStatusChangedBy?: string | null;
    activationStatusChangeDate?: string | null;
    activationStatusChangeReason?: string | null;
};
export type CarrierActiveVm = {
    carrId: string;
    active: number;
    activationStatusChangedBy?: string | null;
    activationStatusChangeDate?: string | null;
    activationStatusChangeReason: string;
};
export type CarrierContactVm = {
    id: number;
    carrierId: string;
    type?: string | null;
    ctitle?: string | null;
    name?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    stateProv?: string | null;
    postal?: string | null;
    phone1Type?: string | null;
    phone1Num?: string | null;
    phone2Type?: string | null;
    phone2Num?: string | null;
    email1?: string | null;
    email2?: string | null;
    createdBy?: string | null;
    createdDate?: string | null;
    updatedBy?: string | null;
    updatedDate?: string | null;
    lastUsed?: string | null;
};
export type CarrierModeMapVm = {
    id: number;
    carrierId: string;
    carrierMode: string;
    plMode: string;
};
export type CarrierPaymentRemitVm = {
    id: number;
    carrierId: string;
    payCurrency: string;
    payHow: string;
    isDefaultPayMethod?: boolean | null;
    payFromAcct: string;
    nickName?: string | null;
    payTermDays?: number | null;
    achrouting?: string | null;
    achaccount?: string | null;
    remitName?: string | null;
    remitAddr1?: string | null;
    remitAddr2?: string | null;
    remitCity?: string | null;
    remitStateProv?: string | null;
    remitPostal?: string | null;
    remitEmail?: string | null;
    remitEffective?: string;
    remitExpire?: string | null;
    remitDeliverHow: string;
    remitFormat?: string | null;
    remitDirectory?: string | null;
    isactrlNum820?: number | null;
    rcvIdqual820?: string | null;
    rcvId820?: string | null;
    seccode?: string | null;
    fileNameMask?: string | null;
    edi820SenderIdQual?: string | null;
    edi820SenderId?: string | null;
    remitConfigName?: string | null;
};
export type ApprovedBatchMinimalVm = {
    batchId?: number;
    approvedDate?: string;
};
export type CarrInvRemarkVm = {
    invIdx?: number | null;
    remarkSeq?: number;
    longComment?: string | null;
};
export type CarrInvRefVm = {
    id?: number;
    carrierId?: string | null;
    grpNum?: number | null;
    invIdx?: number | null;
    invoiceNum?: string | null;
    invRev?: number;
    recType?: string | null;
    refDate?: string | null;
    refDescrip?: string | null;
    refId?: string | null;
    refIdQual?: string | null;
    refSeq?: number;
    refTimecode?: string | null;
    ruleUsed?: number;
    fpsCustId?: string | null;
    ascCodeDescription?: string | null;
};
export type CarrInvCwtVm = {
    actualClass?: number;
    carrierId?: string | null;
    cube?: number;
    id?: string;
    invIdx?: number;
    invoiceNum?: string | null;
    invRev?: number;
    lineItemSeq?: number;
    pcs?: number;
    rate?: number;
    ratedAmt?: number | null;
    ratedClass?: number;
    recType?: string | null;
    weight?: number;
};
export type CarrInvDatesVm = {
    recType?: string | null;
    carrierId?: string | null;
    invoiceNum?: string | null;
    invRev?: number;
    invIdx?: number | null;
    dateSeq?: number;
    dateQual?: string | null;
    stopDate?: string | null;
    timeCode?: string | null;
    stopTime?: string | null;
    timeQual?: string | null;
};
export type CarrInvLineMeasVm = {
    carrierId?: string | null;
    height?: number | null;
    industry?: string | null;
    invIdx?: number | null;
    invoiceNum?: string | null;
    invRev?: number;
    length?: number | null;
    lineIdx?: number | null;
    lineSeq?: number;
    measSeq?: number;
    measUom?: string | null;
    quantity?: number | null;
    recType?: string | null;
    width?: number | null;
};
export type CarrInvLinePartyVm = {
    addr1?: string | null;
    addr2?: string | null;
    addr3?: string | null;
    addr4?: string | null;
    btid?: string | null;
    carrierId?: string | null;
    city?: string | null;
    countryCode?: string | null;
    countrySub?: string | null;
    entityIdcode?: string | null;
    entRelCode?: string | null;
    entRelIdcode?: string | null;
    idcode?: string | null;
    idcodeQual?: string | null;
    idx?: number;
    invIdx?: number | null;
    invoiceNum?: string | null;
    invRev?: number;
    lineIdx?: number | null;
    lineSeq?: number;
    locId?: string | null;
    locQual?: string | null;
    name?: string | null;
    name2?: string | null;
    name3?: string | null;
    partyType?: string | null;
    postalCode?: string | null;
    recType?: string | null;
    stateProv?: string | null;
    sysLocId?: string | null;
    fpsCustId?: string | null;
};
export type CarrInvLineRefVm = {
    carrierId?: string | null;
    grpNum?: number | null;
    invIdx?: number | null;
    invoiceNum?: string | null;
    invRev?: number;
    lineIdx?: number | null;
    lineSeq?: number;
    recType?: string | null;
    refDate?: string | null;
    refDescrip?: string | null;
    refId?: string | null;
    refIdQual?: string | null;
    refSeq?: number;
    refTimecode?: string | null;
    ruleUsed?: number;
    ascCodeDescription?: string | null;
    fpsCustId?: string | null;
};
export type ChargeTotalsVm = {
    totalType?: string | null;
    freight?: number;
    deficit?: number;
    fuel?: number;
    accessorial?: number;
    discount?: number;
    net?: number;
    date?: string;
};
export type CarrInvLineVm = {
    airbillNum?: string | null;
    airbillRev?: number;
    apprAccessorial?: number | null;
    apprAccess?: number | null;
    apprBatchId?: number;
    apprDeficit?: number | null;
    apprDiscount?: number | null;
    apprFuel?: number | null;
    apprGross?: number | null;
    apprNetDue?: number | null;
    apprNet?: number | null;
    auditAccess?: number | null;
    auditContract?: number | null;
    auditDate?: string;
    auditDeficit?: number | null;
    auditDiscount?: number | null;
    auditFlag?: boolean;
    auditFuel?: number | null;
    auditGross?: number | null;
    auditMiles?: number;
    auditNet?: number | null;
    auditRateIs?: string | null;
    auditResult?: string | null;
    auditVariance?: number;
    autoAuditResult?: string | null;
    bmAccessorial?: number;
    bmDeficit?: number;
    bmDiscount?: number;
    bmFuel?: number;
    bmGross?: number;
    bmNetDue?: number;
    bundleNum?: string | null;
    carrierId?: string | null;
    carrInvLineMarks?: CarrInvLineMarksVm[] | null;
    carrInvLineMeas?: CarrInvLineMeasVm[] | null;
    carrInvLineParty?: CarrInvLinePartyVm[] | null;
    carrInvLineQw?: CarrInvLineQwVm[] | null;
    carrInvLineRc?: CarrInvLineRcVm[] | null;
    carrInvLineRef?: CarrInvLineRefVm[] | null;
    carrInvLineTariff?: CarrInvLineTariffVm[] | null;
    cashReceiptId?: number | null;
    checkNumber?: number | null;
    createDate?: string | null;
    currAccessorial?: number;
    currAmtDue?: number;
    currDeficit?: number;
    currDiscount?: number;
    currFuel?: number;
    currGross?: number;
    custComment?: string | null;
    custSvcDescr?: string | null;
    decomment?: string | null;
    dupeFlag?: boolean;
    entryTime?: number;
    equipment?: string | null;
    estDelivDate?: string | null;
    estDelivDays?: number;
    evcity?: string | null;
    evcode?: string | null;
    evcountry?: string | null;
    evdate?: string;
    evdelayHrs?: number;
    event?: string | null;
    evfuelGal?: number;
    evmessage?: string | null;
    evnumCars?: number;
    evnumEmpty?: number;
    evnumLoaded?: number;
    evsecSplc?: string | null;
    evsplc?: string | null;
    evstateProv?: string | null;
    evstatReasCode?: string | null;
    evtime?: string | null;
    evtimeZone?: string | null;
    evtotGross?: number;
    evtotLen?: number;
    evtrainDelayReasCode?: string | null;
    fundedAmt?: number;
    ibob?: string | null;
    idx?: number;
    invIdx?: number | null;
    invoiceNum?: string | null;
    invRev?: number;
    lane?: string | null;
    lastUpdateDate?: string | null;
    lastUpdateUser?: string | null;
    lineSeq?: number;
    mode?: string | null;
    netDue?: number | null;
    paidAccessorial?: number | null;
    paidAccess?: number | null;
    paidDeficit?: number | null;
    paidDiscount?: number | null;
    paidFuel?: number | null;
    paidGross?: number | null;
    paidNetDue?: number | null;
    paidNet?: number | null;
    payBatchId?: number;
    payStatus?: string | null;
    poddate?: string;
    podname?: string | null;
    podtime?: string | null;
    podzone?: string | null;
    pudate?: string;
    pudateQual?: string | null;
    pudelCode?: string | null;
    puequipInit?: string | null;
    puequipNum?: string | null;
    punumShip?: number;
    purpose?: string | null;
    putime?: string | null;
    rcvBatchId?: number;
    recType?: string | null;
    reviewStatus?: string | null;
    serviceLevel?: string | null;
    shipDate?: string;
    svcFail?: boolean;
    termsDescrip?: string | null;
    totalAccessorial?: number | null;
    totalAccum1?: number;
    totalAccum2?: number;
    totalAccum3?: number;
    totalAccum4?: number;
    totalAccum5?: number;
    totalAccum6?: number;
    totalAccum7?: number;
    totalAccum8?: number;
    totalAccum9?: number;
    totalDeficit?: number | null;
    totalDiscount?: number | null;
    totalFuel?: number | null;
    totalGross?: number | null;
    totWgt?: number | null;
    totWgtKilos?: number | null;
    totwgtPounds?: number | null;
    totWgtQual?: string | null;
    totWgtTons?: number | null;
    verifyNetDue?: number | null;
    btId?: string | null;
    customerId?: string | null;
    fpsCustId?: string | null;
    carrier?: CarrierMinimalVm;
    shipper?: PartyVm;
    consignee?: PartyVm;
    parties?: CarrInvLinePartyVm[] | null;
    references?: CarrInvLineRefVm[] | null;
    chargeTotals?: ChargeTotalsVm[] | null;
    chargeDetails?: LineRcTariffQwMarksVm[] | null;
};
export type CarrInvPartyVm = {
    addr1?: string | null;
    addr2?: string | null;
    addr3?: string | null;
    addr4?: string | null;
    btId?: string | null;
    carrierId?: string | null;
    city?: string | null;
    countryCode?: string | null;
    countrySub?: string | null;
    entIdCode?: string | null;
    entRelCode?: string | null;
    entRelIdCode?: string | null;
    idCode?: string | null;
    idCodeQual?: string | null;
    idx?: number;
    invIdx?: number | null;
    invoiceNum?: string | null;
    invRev?: number;
    locId?: string | null;
    locQual?: string | null;
    name?: string | null;
    name2?: string | null;
    name3?: string | null;
    partyType?: string | null;
    postalCode?: string | null;
    recType?: string | null;
    stateProv?: string | null;
    sysLocId?: string | null;
    fpsCustId?: string | null;
};
export type CarrierInvoiceImagesVm = {
    id?: number;
    carrInvIdx?: number;
    invoiceNum?: string | null;
    carrInvLineIdx?: number | null;
    carrierId?: string | null;
    imageType?: string | null;
    originalFileName?: string | null;
    imageName?: string | null;
    source?: string | null;
    s3Path?: string | null;
    subKey?: string | null;
    fileDate?: string;
    dateLinked?: string;
    image?: string | null;
    contentType?: string | null;
};
export type CarrInvVm = {
    apprAccess?: number | null;
    apprBatchId?: number | null;
    apprDeficit?: number | null;
    apprDiscount?: number | null;
    apprFuel?: number | null;
    apprGross?: number | null;
    apprNetDue?: number | null;
    auditAccess?: number | null;
    auditContract?: number | null;
    auditDate?: string;
    auditDeficit?: number | null;
    auditDiscount?: number | null;
    auditFlag?: boolean;
    auditFuel?: number | null;
    auditGross?: number | null;
    auditMiles?: number | null;
    auditNet?: number | null;
    auditRateIs?: string | null;
    auditResult?: string | null;
    auditVariance?: number;
    autoAuditResult?: string | null;
    bankAccountNum?: string | null;
    bankClientCode?: string | null;
    billingContract?: number;
    billingCurrency?: string | null;
    billingDate?: string | null;
    biNum?: number | null;
    bmAccessorial?: number | null;
    bmDeficit?: number | null;
    bmDiscount?: number | null;
    bmFuel?: number | null;
    bmGross?: number | null;
    bmNetDue?: number | null;
    calcDueDate?: string | null;
    calcReqDate?: string | null;
    carrierId?: string | null;
    cashReceiptId?: number | null;
    checkNumber?: number | null;
    ciNum?: number | null;
    clientBankNum?: string | null;
    contactFcode?: string | null;
    contactInqRef?: string | null;
    contactName?: string | null;
    contactNum1?: string | null;
    contactNum2?: string | null;
    contactNum3?: string | null;
    contactNum4?: string | null;
    correction?: string | null;
    createDate?: string | null;
    createUser?: string | null;
    currAccessorial?: number | null;
    currAmtDue?: number | null;
    currDeficit?: number | null;
    currDiscount?: number | null;
    currFuel?: number | null;
    currGross?: number | null;
    custComment?: string | null;
    custSvcDescr?: string | null;
    dateQual?: string | null;
    delDate?: string | null;
    deleteDate?: string | null;
    deleteUser?: string | null;
    dupeFlag?: boolean;
    ediCustId?: string | null;
    effectivePayDate?: string | null;
    entryTime?: number;
    equipment?: string | null;
    estDelivDate?: string | null;
    estDelivDays?: number | null;
    exchRate?: number | null;
    firstBtId?: string | null;
    fpsCarrId?: string | null;
    fpsCustId?: string | null;
    fpsFileName?: string | null;
    fundedAmt?: number | null;
    fundedDate?: string | null;
    gsCtlNum?: number | null;
    gsRecvId?: string | null;
    gsSendId?: string | null;
    gsTrans?: string | null;
    ibob?: string | null;
    idCode?: string | null;
    idCodeQual?: string | null;
    idx?: number;
    ieaGrpIncl?: number | null;
    inFileName?: string | null;
    invDate2?: string | null;
    invoiceNum?: string | null;
    invRev?: number;
    invType?: string | null;
    isaAckReq?: string | null;
    isaAuthInfo?: string | null;
    isaAuthQual?: string | null;
    isaControlNum?: number | null;
    isaDate?: string | null;
    isaRecvId?: string | null;
    isaRecvQual?: string | null;
    isaRepSep?: string | null;
    isaSecInfo?: string | null;
    isaSecInfoQual?: string | null;
    isaSenderId?: string | null;
    isaSenderIdQual?: string | null;
    isaTestInd?: string | null;
    isaTime?: string | null;
    isaVersionId?: string | null;
    lane?: string | null;
    lastUpdateDate?: string | null;
    lastUpdateUser?: string | null;
    mode?: string | null;
    netDue?: number | null;
    numQual1?: string | null;
    numQual2?: string | null;
    numQual3?: string | null;
    numQual4?: string | null;
    numShipments?: number | null;
    paidAccessorial?: number | null;
    paidDeficit?: number | null;
    paidDiscount?: number | null;
    paidFuel?: number | null;
    paidGross?: number | null;
    paidNetDue?: number | null;
    payBatchId?: number | null;
    payCurrency?: string | null;
    payMeth?: string | null;
    payStatus?: string | null;
    projReqDate?: string | null;
    purpose?: string | null;
    ratedCurrency?: string | null;
    rcvBatchDate?: string | null;
    rcvBatchId?: number | null;
    recType?: string | null;
    reviewStatus?: string | null;
    scac?: string | null;
    serviceLevel?: string | null;
    seSegIncl?: number | null;
    shipDate?: string | null;
    shipIdNum?: string | null;
    shipmentCount?: number | null;
    shipMethPay?: string | null;
    shipperAccount?: string | null;
    shipQual?: string | null;
    source?: string | null;
    stControlNum?: number | null;
    stTransType?: string | null;
    svcFail?: boolean;
    tariffSvcCode?: string | null;
    termsBasisDateCode?: string | null;
    termsDayOfMon?: number | null;
    termsDefAmtDue?: number | null;
    termsDefDueDate?: string | null;
    termsDescrip?: string | null;
    termsDiscAmt?: number | null;
    termsDiscDaysDue?: number | null;
    termsDiscDueDate?: string | null;
    termsDiscountPct?: number | null;
    termsNetDays?: number | null;
    termsNetDueDate?: string | null;
    termsPayMethCode?: string | null;
    termsPct?: number | null;
    termsPctpayable?: number | null;
    termsTypeCode?: string | null;
    test?: string | null;
    totAdv?: number | null;
    totalAccessorial?: number | null;
    totalAccum1?: number | null;
    totalAccum2?: number | null;
    totalAccum3?: number | null;
    totalAccum4?: number | null;
    totalAccum5?: number | null;
    totalAccum6?: number | null;
    totalAccum7?: number | null;
    totalAccum8?: number | null;
    totalAccum9?: number | null;
    totalDeficit?: number | null;
    totalDiscount?: number | null;
    totalFuel?: number | null;
    totalGross?: number | null;
    totChg?: number | null;
    totDeclVal?: number | null;
    totDeclValQual?: string | null;
    totFrtRate?: number | null;
    totFrtRateQual?: string | null;
    totLadQty?: number | null;
    totPrepaid?: number | null;
    totSpecChgCode?: string | null;
    totTariffNum?: string | null;
    totVol?: number | null;
    totVolUom?: string | null;
    totWgt?: number | null;
    totWgtKilos?: number | null;
    totWgtPounds?: number | null;
    totWgtQual?: string | null;
    totWgtTons?: number | null;
    totWgtUom?: string | null;
    transpTermsCode?: string | null;
    transTypeCode?: string | null;
    underCarr?: string | null;
    vdabCarrId?: string | null;
    verifyNetDue?: number | null;
    wgtUnitCode?: string | null;
    approvedBatch?: ApprovedBatchMinimalVm;
    carrier?: CarrierMinimalVm;
    billTo?: BillToMinimalVm;
    carrInvRemark?: CarrInvRemarkVm[] | null;
    shipper?: PartyVm;
    consignee?: PartyVm;
    needsEdiInvoice?: boolean;
    carrInvRef?: CarrInvRefVm[] | null;
    references?: CarrInvRefVm[] | null;
    carrInvCwt?: CarrInvCwtVm[] | null;
    carrInvDates?: CarrInvDatesVm[] | null;
    carrInvLine?: CarrInvLineVm[] | null;
    carrInvParty?: CarrInvPartyVm[] | null;
    carrInvImages?: CarrierInvoiceImagesVm[] | null;
    parties?: CarrInvPartyVm[] | null;
    chargeTotals?: ChargeTotalsVm[] | null;
    chargeDetails?: LineRcTariffQwMarksVm[] | null;
};
export type CarrInvLineMinimalVm = {
    airbillNum?: string | null;
    apprNetDue?: number;
    auditNet?: number;
    custComment?: string | null;
    invIdx?: number;
    invRev?: number;
    lineIdx?: number;
    lineSeq?: number;
    mode?: string | null;
    netDue?: number;
    selected?: boolean;
    serviceLevel?: string | null;
    status?: string | null;
    carrInvLineRc?: CarrInvLineRcVm[] | null;
    carrInvLineQw?: CarrInvLineQwVm[] | null;
    carrInvLineTariff?: CarrInvLineTariffVm[] | null;
    carrInvLineMarks?: CarrInvLineMarksVm[] | null;
};
export type CarrInvMinimalVm = {
    apprNetDue?: number;
    auditNetDue?: number;
    billingCurrency?: string | null;
    billTo?: BillToMinimalVm;
    carrierId?: string | null;
    carrier?: CarrierMinimalVm;
    comment?: string | null;
    fpsCustId?: string | null;
    idx?: number;
    invoiceDate?: string;
    createDate?: string;
    createUser?: string | null;
    shipDate?: string;
    invoiceNum?: string | null;
    source?: string | null;
    purpose?: string | null;
    invRev?: number;
    invType?: string | null;
    isaSenderID?: string | null;
    mode?: string | null;
    netDue?: number;
    selected?: boolean;
    status?: string | null;
    recType?: string | null;
    ibob?: string | null;
    reviewStatus?: string | null;
    carrInvLine?: CarrInvLineMinimalVm[] | null;
};
export type InitiateMultiPartInvoiceCreationResponse = {
    invoiceId?: number;
    creationId?: string | null;
};
export type InitiateMultiPartInvoiceCreationRequest = {
    invoice?: CarrInvVm;
};
export type InvoicePartResponse = {
    tag?: string | null;
    partNumber?: number;
};
export type InvoicePartRequest = {
    invoiceId?: number;
    creationId?: string | null;
    partNumber?: number;
    lineItems?: CarrInvLineVm[] | null;
};
export type CompleteMultiPartInvoiceCreationResponse = {
    invoiceId?: number;
    errorMessage?: string | null;
    serverTrackedCompletedParts?: InvoicePartResponse[] | null;
};
export type CompleteMultiPartInvoiceCreationRequest = {
    invoiceId?: number;
    creationId?: string | null;
    completedParts?: InvoicePartResponse[] | null;
};
export type AbortMultiPartInvoiceCreationRequest = {
    invoiceId?: number;
    creationId?: string | null;
};
export type QueuedInvoiceCreationResponse = {
    queueId?: string | null;
};
export type InvoiceCreationStatusResponse = {
    queueId?: string | null;
    status?: string | null;
};
export type InvoiceCreationStatusRequest = {
    invoiceId?: number;
    queueId?: string | null;
    multiPart?: boolean;
    creationId?: string | null;
};
export type WhatIfChargeCodeMapVm = {
    originalChargeDescr?: string | null;
    originalChargeCode?: string | null;
    specChargeCode?: string | null;
    specChgDescr?: string | null;
    totalsColumn?: string | null;
    rcSeq?: number;
    lineIdx?: number | null;
    invIdx?: number | null;
};
export type CarrServicesVm = {
    carrierId: string;
    serviceCode: string;
    serviceDescription?: string | null;
    svcAuditFunction?: string | null;
    isDefault?: boolean | null;
    checkForDuplicate?: boolean;
    displayForInvoiceEntry?: boolean;
};
export type CmContractVm = {
    carrierId: string;
    carrierName?: string | null;
    billToId: string;
    billToName?: string | null;
    service: string;
    rateAudit: boolean;
    svcAudit: boolean;
    cmBillContractId: number;
    cmCostContractId: number;
    bcClassReq: boolean;
    bcWeightReq: boolean;
    ccClassReq: boolean;
    ccWeightReq: boolean;
    netDueDays: number;
    netDiscountDays: number;
    netDiscountPct: number;
};
export type CodeMasterVm = {
    element: string;
    code: string;
    description: string;
    preferredOrder?: string | null;
};
export type CodeMasterElements = {
    elementList?: string[] | null;
    defaultElement?: string | null;
};
export type StatusMasterVm = {
    status?: string | null;
    sequence?: number | null;
    statGroup?: string | null;
    showInWeb?: boolean | null;
    showInDashboard?: boolean;
    id?: number;
    isAuditFailStatus?: boolean;
};
export type ContactsVm = {
    id: number;
    btid: string;
    type?: string | null;
    ctitle?: string | null;
    code?: string | null;
    name?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    stateProv?: string | null;
    postal?: string | null;
    phone1Type?: string | null;
    phone1Num?: string | null;
    phone2Type?: string | null;
    phone2Num?: string | null;
    email1?: string | null;
    email2?: string | null;
    comments?: string | null;
    createdBy?: string | null;
    createdDate?: string;
    updatedBy?: string | null;
    updatedDate?: string;
    lastUsed?: string;
    useOnFeeInvoice?: boolean | null;
};
export type CurrenciesVm = {
    countryCode: string;
    id: string;
    countryName?: string | null;
    description?: string | null;
    symbol?: string | null;
    inUse?: boolean;
};
export type CustomerDataEntryGridVm = {
    id?: number;
    btid?: string | null;
    carrierId?: string | null;
    ascrefCode?: string | null;
    dispOrder?: number;
    customerDescription?: string | null;
    allowMulti?: string | null;
    requiredFieldIndicator?: string | null;
    detailLocation?: string | null;
    fieldFormat?: string | null;
    validationTechnique?: string | null;
    tipText?: string | null;
    selected?: string | null;
    longDescription?: string | null;
    inUse?: string | null;
};
export type CreateReceivableBatchesForCustomersVm = {
    batchDate?: string;
    projectedRequestDatesToInclude?: string | null;
    customers?: string[] | null;
};
export type ReceivableBatchResultVm = {
    billToId?: string | null;
    carrierId?: string | null;
    batchId?: number;
};
export type CustPaySetupVm = {
    active?: boolean;
    btId: string;
    carrId: string;
    createDate?: string;
    createUser?: string | null;
    id: number;
    lastUpdateDate?: string;
    lastUpdateUser?: string | null;
    mode?: string | null;
};
export type ShipmentCountByStatusVm = {
    status?: string | null;
    invoiceCount?: number;
    invoiceAmount?: number;
    currency?: string | null;
};
export type AgedInvoiceSummaryVm = {
    requestDate?: string | null;
    invoices?: number;
    shipments?: number | null;
    amountDue?: number | null;
    currency?: string | null;
};
export type DeAdminVm = {
    btid: string;
    btName?: string | null;
    carrierId: string;
    carrierName?: string | null;
    invDetCurrSelShow?: number | null;
    invDetCurrSelReq?: number | null;
    invDetCurrExchShow?: number | null;
    invDetCurrExchReq?: number | null;
    invDetDelDateShow?: number | null;
    invDetDelDateReq?: number | null;
    invDetTermsShow?: number | null;
    invDetTermsReq?: number | null;
    invDetIbobshow?: number | null;
    invDetIbobreq?: number | null;
    grpTotalsShow?: number | null;
    totalsGrossShow?: number | null;
    totalsGrossReq?: number | null;
    totalsDeficitShow?: number | null;
    totalsDeficitReq?: number | null;
    totalsFuelShow?: number | null;
    totalsFuelReq?: number | null;
    totalsAccessShow?: number | null;
    totalsAccessReq?: number | null;
    totalsDiscShow?: number | null;
    totalsDiscReq?: number | null;
    grpShipperShow?: number | null;
    shipperAutoFill?: number | null;
    shipperPostalShow?: number | null;
    shipperPostalReq?: number | null;
    shipperNameShow?: number | null;
    shipperNameReq?: number | null;
    shipperAddr1Show?: number | null;
    shipperAddr1Req?: number | null;
    shipperAddr2Show?: number | null;
    shipperAddr2Req?: number | null;
    shipperAddr3Show?: number | null;
    shipperAddr3Req?: number | null;
    shipperAddr4Show?: number | null;
    shipperAddr4Req?: number | null;
    shipperCityShow?: number | null;
    shipperCityReq?: number | null;
    shipperStateShow?: number | null;
    shipperStateReq?: number | null;
    grpCnsShow?: number | null;
    cnsAutoFill?: number | null;
    cnsPostalShow?: number | null;
    cnsPostalReq?: number | null;
    cnsNameShow?: number | null;
    cnsNameReq?: number | null;
    cnsAddr1Show?: number | null;
    cnsAddr1Req?: number | null;
    cnsAddr2Show?: number | null;
    cnsAddr2Req?: number | null;
    cnsAddr3Show?: number | null;
    cnsAddr3Req?: number | null;
    cnsAddr4Show?: number | null;
    cnsAddr4Req?: number | null;
    cnsCityShow?: number | null;
    cnsCityReq?: number | null;
    cnsStateShow?: number | null;
    cnsStateReq?: number | null;
    grpLidshow?: number | null;
    lidpiecesShow?: number | null;
    lidpiecesReq?: number | null;
    lidpackShow?: number | null;
    lidpackReq?: number | null;
    lidunitsShow?: number | null;
    lidunitsReq?: number | null;
    lidqtyShow?: number | null;
    lidqtyReq?: number | null;
    lidweightShow?: number | null;
    lidweightReq?: number | null;
    lidclassShow?: number | null;
    lidclassReq?: number | null;
    lidhazShow?: number | null;
    lidhazReq?: number | null;
    lidchgCodeShow?: number | null;
    lidchgCodeReq?: number | null;
    lidchgAmtShow?: number | null;
    lidchgAmtReq?: number | null;
    liddescrShow?: number | null;
    liddescrReq?: number | null;
    lidcommodityShow?: number | null;
    lidcommodityReq?: number | null;
    grpRefDataShow?: number | null;
    custAcctShow?: number | null;
    custAcctReq?: number | null;
    invEquipShow?: number | null;
    invEquipReq?: number | null;
    invModeShow?: number | null;
    invModeReq?: number | null;
    invServiceShow?: number | null;
    invServiceReq?: number | null;
    shipModeReq?: number | null;
    shipModeShow?: number | null;
    shipEquipReq?: number | null;
    shipEquipShow?: number | null;
    shipServiceShow?: number | null;
    shipServiceReq?: number | null;
    shipTermsShow?: number | null;
    shipTermsReq?: number | null;
    shipIbobshow?: number | null;
    shipIbobreq?: number | null;
    shipDelDateShow?: number | null;
    shipDelDateReq?: number | null;
};
export type DateExportStatus = 'Pending' | 'Processing' | 'Done';
export type DataExportsVm = {
    id?: number;
    statusId?: DateExportStatus;
    statusIdDisplay?: string | null;
    userJobName?: string | null;
    s3Bucket?: string | null;
    s3Key?: string | null;
    jobCreatedDate?: string;
    jobCompletedDate?: string | null;
};
export type ExportFileFormat = 'csv' | 'xlsx';
export type ModeVm = {
    code: string;
    value?: string | null;
    description?: string | null;
    label?: string | null;
};
export type StatusCodeVm = {
    code: string;
    description?: string | null;
};
export type EntryMethodVm = {
    code: string;
    description?: string | null;
    selected?: boolean;
};
export type DateTimeRangeVm = {
    start?: string | null;
    end?: string | null;
};
export type InvoiceResearchOptionsVm = {
    carriers?: CarrierMinimalVm[] | null;
    billTos?: BillToMinimalVm[] | null;
    mode?: ModeVm[] | null;
    statusCodes?: StatusCodeVm[] | null;
    referenceCodes?: AscReferenceCodeVm[] | null;
    entryMethods?: EntryMethodVm[] | null;
    processed?: DateTimeRangeVm;
    checkDate?: DateTimeRangeVm;
    shipped?: DateTimeRangeVm;
    invoices?: string | null;
    airBillNums?: string | null;
    checks?: string | null;
    findReference?: string | null;
    shipper?: PartyVm;
    consignee?: PartyVm;
    sortBy?: string | null;
    page?: number | null;
    recordCountRequested?: number | null;
    requestedRecordCount?: number;
    declaredCount?: number | null;
    sortAscending?: boolean;
};
export type EmailVm = {
    to?: string | null;
    cc?: string | null;
    subject?: string | null;
    body?: string | null;
};
export type TargetLevel = 'All' | 'CarrierInvoice' | 'CarrierInvoiceLine';
export type GlBulkCodingRequest = {
    btid?: string | null;
    endDate?: string | null;
    level?: TargetLevel;
    overwriteExistingGlCodes?: boolean;
    startDate?: string | null;
    socketId?: string | null;
};
export type GlCodingRequest = {
    addGlRefRecords?: boolean;
    invoiceId?: number;
    level?: TargetLevel;
};
export type HopkinsDepartmentData = {
    accountNum?: string | null;
    outboundCountry?: string | null;
};
export type HopkinsDepartmentVm = {
    billToId?: string | null;
    departments?: string | null;
    comments?: string | null;
    additionalData?: HopkinsDepartmentData;
};
export type ImageType =
    | 'None'
    | 'AddPage'
    | 'BL_1'
    | 'BL_2'
    | 'BL_3'
    | 'BL_4'
    | 'BL_5'
    | 'BL_6'
    | 'BL_7'
    | 'BOL'
    | 'CINV'
    | 'DR_1'
    | 'DR_2'
    | 'DR_3'
    | 'EDIInvoice'
    | 'Images'
    | 'INV'
    | 'Invoice'
    | 'LOA'
    | 'Misc'
    | 'OTHER'
    | 'POD';
export type DisconnectedCarrInvImagesVm = {
    id?: number;
    carrierId?: string | null;
    carrierName?: string | null;
    invoiceNum?: string | null;
    revNum?: number;
    invIdx?: number;
    shipmentNum?: string | null;
    imageType?: ImageType;
    possibly?: string | null;
    imagePath?: string | null;
    imageFileName?: string | null;
    creationTime?: string;
    dateLinked?: string;
};
export type DataPairVm = {
    name?: string | null;
    display?: string | null;
    value?: string | null;
};
export type ChargeLineVm = {
    displayOrder?: number;
    type?: string | null;
    freight?: number;
    deficit?: number;
    fuel?: number;
    accessorial?: number;
    discount?: number;
    net?: number;
};
export type BasicInfoVm = {
    invoiceInfo?: DataPairVm[] | null;
    chargeLines?: ChargeLineVm[] | null;
    invoiceNum?: string | null;
    airBillNum?: string | null;
    custComment?: string | null;
    auditComment?: string | null;
    carrier?: CarrierMinimalVm;
    shipper?: PartyVm;
    consignee?: PartyVm;
};
export type BasicInfoVmGetResponse = {
    invoice?: BasicInfoVm;
    requireEditPreAudit?: boolean;
    isWebLocked?: boolean;
    showReleaseBtn?: boolean;
};
export type DetailedChargeVm = {
    invIdx?: number;
    lineIdx?: number;
    rcSeq?: number;
    displayOrder?: number;
    pieces?: number | null;
    units?: string | null;
    weight?: number | null;
    class?: string | null;
    itemDescription?: string | null;
    chargeDescription?: string | null;
    chargeAmount?: number | null;
    currency?: string | null;
    auditAmount?: number | null;
};
export type DetailedChargeListVm = {
    detailedCharges?: DetailedChargeVm[] | null;
    totalWeight?: number;
    totalCharge?: number;
    currency?: string | null;
};
export type InvType = 'Single' | 'Statement';
export type UnifiedInvRefVm = {
    id?: number;
    invIdx?: number | null;
    lineIdx?: number | null;
    recType?: string | null;
    carrierId?: string | null;
    invoiceNum?: string | null;
    invRev?: number;
    lineSeq?: number;
    refSeq?: number;
    refIdQual?: string | null;
    refId?: string | null;
    refDescrip?: string | null;
    refDate?: string | null;
    refTimecode?: string | null;
    ruleUsed?: number;
    grpNum?: number | null;
    ascCodeDescription?: string | null;
    fpsCustId?: string | null;
    modified?: boolean;
};
export type ReferenceListVm = {
    references?: UnifiedInvRefVm[] | null;
    accountCodingData?: UnifiedInvRefVm[][] | null;
    deletedAccountCodingData?: UnifiedInvRefVm[][] | null;
    accountCodingHeaders?: UnifiedInvRefVm[] | null;
    showAccountCoding?: boolean;
    showReleaseInvoiceButton?: boolean;
    revReason?: string | null;
};
export type ImageListVm = {
    images?: CarrierInvoiceImagesVm[] | null;
    needsEdiInvoice?: boolean;
};
export type InvoiceComment = {
    comment?: string | null;
};
export type InvoiceResearchListVm = {
    invIdx?: number | null;
    lineIdx?: number;
    billToName?: string | null;
    carrierName?: string | null;
    carrierNameLink?: string | null;
    invoiceNum?: string | null;
    invoiceNumLink?: string | null;
    invoiceReviewStatus?: string | null;
    shipmentNum?: string | null;
    shipmentNumLink?: string | null;
    shipmentReviewStatus?: string | null;
    enteredDate?: string | null;
    createDate?: string | null;
    shipDateFormatted?: string | null;
    shipDate?: string | null;
    source?: string | null;
    purpose?: string | null;
    mode?: string | null;
    ibob?: string | null;
    invType?: string | null;
    invDate?: string | null;
    billingDate?: string | null;
    currAmtDue?: number | null;
    auditFlag?: boolean | null;
    shipperName?: string | null;
    shipperCity?: string | null;
    shipperState?: string | null;
    shipperPostal?: string | null;
    consigneeName?: string | null;
    consigneeCity?: string | null;
    consigneeState?: string | null;
    consigneePostal?: string | null;
    totWgtPounds?: number | null;
    rcvBatchId?: number | null;
    procDate?: string | null;
    rcvBatchDate?: string | null;
    paidNetDue?: number | null;
    checkNumber?: number | null;
    checkDateFormatted?: string | null;
    checkDate?: string | null;
    payMethod?: string | null;
    custComment?: string | null;
    isaSenderId?: string | null;
    userSpecificReferences?: string[] | null;
};
export type InvoiceResearchListVmPagingResponse = {
    data?: InvoiceResearchListVm[] | null;
    total?: number | null;
    isError?: boolean;
    error?: string | null;
};
export type MakeRealVm = {
    customer?: string | null;
    invDate?: string;
    status?: string | null;
};
export type ExceptionManagerListVm = {
    invIdx?: number;
    lineIdx?: number;
    lineSeq?: number;
    invType?: string | null;
    carrierId?: string | null;
    carrierName?: string | null;
    customerId?: string | null;
    customerName?: string | null;
    invoiceNum?: string | null;
    airbillNum?: string | null;
    reviewStatus?: string | null;
    shipDate?: string | null;
    netDue?: number | null;
    auditNet?: number | null;
    auditResult?: string | null;
    shipperPartyId?: number | null;
    shipperName?: string | null;
    shipperPostal?: string | null;
    consigneePartyId?: number | null;
    consigneeName?: string | null;
    consigneePostal?: string | null;
    billingDate?: string | null;
    createDate?: string | null;
    totLadQty?: number | null;
    totWgt?: number | null;
    createUser?: string | null;
    invRev?: number;
    comment?: string | null;
    custComment?: string | null;
};
export type ExceptionManagerActionVm = {
    invoicesToActOn: ExceptionManagerListVm[];
    comments: string;
};
export type ExceptionManagerListAcceptAsAdjustedVm = {
    adjustedCharges?: LineRcTariffQwMarksVm[] | null;
    invoiceLevelAdjustment?: number | null;
    invIdx?: number;
    lineIdx?: number;
    lineSeq?: number;
    invType?: string | null;
    carrierId?: string | null;
    carrierName?: string | null;
    customerId?: string | null;
    customerName?: string | null;
    invoiceNum?: string | null;
    airbillNum?: string | null;
    reviewStatus?: string | null;
    shipDate?: string | null;
    netDue?: number | null;
    auditNet?: number | null;
    auditResult?: string | null;
    shipperPartyId?: number | null;
    shipperName?: string | null;
    shipperPostal?: string | null;
    consigneePartyId?: number | null;
    consigneeName?: string | null;
    consigneePostal?: string | null;
    billingDate?: string | null;
    createDate?: string | null;
    totLadQty?: number | null;
    totWgt?: number | null;
    createUser?: string | null;
    invRev?: number;
    comment?: string | null;
    custComment?: string | null;
};
export type ExceptionManagerAcceptAsAdjustedVm = {
    invoicesToActOn: ExceptionManagerListAcceptAsAdjustedVm[];
    comments: string;
};
export type CarrierChargeCodeSourceGenericDropDownStruct = {
    value?: CarrierChargeCodeSource;
    display?: string | null;
};
export type PayablesExceptionsVm = {
    id: number;
    customerID: string;
    customerName?: string | null;
    carrierID: string;
    payMethodID: number;
};
export type PayDaysStartVm = {
    indicator: number;
    description: string;
};
export type PermittedValuesVm = {
    id: number;
    carrierId: string;
    btid: string;
    fieldName: string;
    permittedValue: string;
};
export type PostalCodeVm = {
    id: number;
    zip51: string;
    city: string;
    state: string;
    country: string;
};
export type StatesVm = {
    id: number;
    country: string;
    abbrev: string;
    stateName: string;
};
export type UserTcactivityVm = {
    id?: string;
    tcid?: string;
    activity?: string | null;
    startTime?: string | null;
    stopTime?: string | null;
    notes?: string | null;
    userTimeCard?: UserTimeCardVm;
};
export type UserTimeCardVm = {
    id?: string;
    userId?: string | null;
    cardDate?: string;
    totalHrs?: number;
    locked?: boolean;
    activities?: UserTcactivityVm[] | null;
};
export type UserBillToVm = {
    id?: number;
    userId: string;
    btid: string;
};
export type UserSessionsVm = {
    session?: string;
    userId?: string | null;
    sessionStart?: string;
    sessionEnd?: string;
    sessionTime?: number | null;
    sessionEndStatus?: string | null;
    hostName?: string | null;
};
export type CarrInvUserStatsVm = {
    entrySeconds?: number;
    invoiceCount?: number;
    lastSave?: string;
    shipmentCount?: number;
};
export const {
    useRequeueJobQuery,
    useLazyRequeueJobQuery,
    useGetAppDefaultsQuery,
    useLazyGetAppDefaultsQuery,
    usePutAppDefaultsMutation,
    useGetInvoicesApprovalPopulationDataQuery,
    useLazyGetInvoicesApprovalPopulationDataQuery,
    useGetInvoicesNeedingApprovalMutation,
    useGetMinimalInvoiceDetailQuery,
    useLazyGetMinimalInvoiceDetailQuery,
    useApproveInvoicesMutation,
    useSaveCurrentInvoiceStateMutation,
    usePostApiApproveInvoicesFromInvoiceIdxsMutation,
    useGetAllAscChargeCodesQuery,
    useLazyGetAllAscChargeCodesQuery,
    useCreateAscChargeCodesMutation,
    useModifyAscChargeCodesMutation,
    useDeleteAscChargeCodesMutation,
    useGetInvoiceChargeTypesQuery,
    useLazyGetInvoiceChargeTypesQuery,
    useGetAllAscRefCodesQuery,
    useLazyGetAllAscRefCodesQuery,
    useCreateAscRefCodesMutation,
    useModifyAscRefCodesMutation,
    useDeleteAscRefCodesMutation,
    useGetGenMilesMutation,
    useLoginMutation,
    useRefreshTokenQuery,
    useLazyRefreshTokenQuery,
    useLoginWithPermissionsMutation,
    useRefreshWithPermissionsQuery,
    useLazyRefreshWithPermissionsQuery,
    useLogOutQuery,
    useLazyLogOutQuery,
    useGetMyUserQuery,
    useLazyGetMyUserQuery,
    useGetAllBankAccountsQuery,
    useLazyGetAllBankAccountsQuery,
    useGetBillToByIdQuery,
    useLazyGetBillToByIdQuery,
    useGetDataEntryAscRefCodesQuery,
    useLazyGetDataEntryAscRefCodesQuery,
    useGetAllBillToQuery,
    useLazyGetAllBillToQuery,
    useGetBillToForDisplayQuery,
    useLazyGetBillToForDisplayQuery,
    useGetCustomerByIdQuery,
    useLazyGetCustomerByIdQuery,
    useModifyCustomersMutation,
    useDeleteCustomersMutation,
    useGetAllCustomersQuery,
    useLazyGetAllCustomersQuery,
    useCreateCustomersMutation,
    useGetParentCustomersQuery,
    useLazyGetParentCustomersQuery,
    useActivateCustomersMutation,
    useGetModeDefaultsByCustomerQuery,
    useLazyGetModeDefaultsByCustomerQuery,
    useCreateBillToModeDefaultMutation,
    useModifyBillToModeDefaultMutation,
    useDeleteBillToModeDefaultMutation,
    useGetBillToMapsByCarrierQuery,
    useLazyGetBillToMapsByCarrierQuery,
    useCreateCarrierBtMapMutation,
    useDeleteCarrierBtMapMutation,
    useGetCarrierEdiMasterByIdQuery,
    useLazyGetCarrierEdiMasterByIdQuery,
    useCreateCarrierEdiMasterMutation,
    useModifyCarrierEdiMasterMutation,
    useDeleteCarrierEdiMasterMutation,
    useGetAllCarrierFamiliesQuery,
    useLazyGetAllCarrierFamiliesQuery,
    useGetCarriersForDropdownQuery,
    useLazyGetCarriersForDropdownQuery,
    useGetByScacQuery,
    useLazyGetByScacQuery,
    useGetCarrierChargeCodeMappingQuery,
    useLazyGetCarrierChargeCodeMappingQuery,
    useGetCarrierChargeCodeMappingByIdQuery,
    useLazyGetCarrierChargeCodeMappingByIdQuery,
    useAddNewCarrierChargeCodeMappingMutation,
    useUpdateCarrierChargeCodeMappingMutation,
    useDeletCarrierChargeCodeMappingMutation,
    useGetCarrierChargeCodeMappingOverridesQuery,
    useLazyGetCarrierChargeCodeMappingOverridesQuery,
    useGetCarrierChargeCodeMappingOverrideByCarrierIdQuery,
    useLazyGetCarrierChargeCodeMappingOverrideByCarrierIdQuery,
    useAddNewCarrierChargeCodeMappingOverrideMutation,
    useUpdateCarrierChargeCodeMappingOverrideMutation,
    useDeleteCarrierChargeCodeMappingOverrideMutation,
    useGetCarrierByIdQuery,
    useLazyGetCarrierByIdQuery,
    useGetAllCarriersQuery,
    useLazyGetAllCarriersQuery,
    useCreateCarriersMutation,
    useModifyCarriersMutation,
    useDeleteCarriersMutation,
    useActivateCarriersMutation,
    useGetAllCarrierContactsQuery,
    useLazyGetAllCarrierContactsQuery,
    useCreateCarrierContactsMutation,
    useGetCarrierContactByIdQuery,
    useLazyGetCarrierContactByIdQuery,
    useModifyCarrierContactsMutation,
    useDeleteCarrierContactsMutation,
    useGetCarrierModeMapsByIdQuery,
    useLazyGetCarrierModeMapsByIdQuery,
    useCreateCarrierModeMapsMutation,
    useModifyCarrierModeMapsMutation,
    useDeleteCarrierModeMapsMutation,
    useGetPayMethodsForCarrierQuery,
    useLazyGetPayMethodsForCarrierQuery,
    useCreateCarrierPayRemitMutation,
    useModifyCarrierPayRemitMutation,
    useDeleteCarrierPayRemitMutation,
    useGetCarrierRemitMethodsQuery,
    useLazyGetCarrierRemitMethodsQuery,
    useGetCarrierRemitDeliveryMethodsQuery,
    useLazyGetCarrierRemitDeliveryMethodsQuery,
    useGetCarrierRemitFormatsQuery,
    useLazyGetCarrierRemitFormatsQuery,
    useGetAchSecCodesQuery,
    useLazyGetAchSecCodesQuery,
    useGetCarrierInvoiceByIdQuery,
    useLazyGetCarrierInvoiceByIdQuery,
    useGetInvoiceSummaryQuery,
    useLazyGetInvoiceSummaryQuery,
    useGetInvoiceLineSummaryQuery,
    useLazyGetInvoiceLineSummaryQuery,
    useGetInvoiceChargeDetailsQuery,
    useLazyGetInvoiceChargeDetailsQuery,
    useGetInvoiceLineChargeDetailsQuery,
    useLazyGetInvoiceLineChargeDetailsQuery,
    useCreateMutation,
    useInitiateMultiPartInvoiceCreationMutation,
    useMultiPartInvoiceCreationMutation,
    useCompleteMultiPartInvoiceCreationMutation,
    useAbortMultiPartInvoiceCreationMutation,
    useCreateQueuedMutation,
    usePostApiCarrInvCheckQueuedInvoiceCreationStateMutation,
    useValidateCodingMutation,
    useValidateLineCodingMutation,
    useCreateBillingInvoiceMutation,
    useCreateBillingInvoiceQueuedMutation,
    useCreatePdfInvoiceMutation,
    useCreatePdfInvoiceQueuedMutation,
    useRegeneratePdfInvoiceMutation,
    useGetImagesForInvoiceQuery,
    useLazyGetImagesForInvoiceQuery,
    useAddImageMutation,
    useClearCachedImagesForInvoiceMutation,
    useGetImageWithDataQuery,
    useLazyGetImageWithDataQuery,
    useGetImageWithDataFromObjectMutation,
    useCarrInvDisconnectImageMutation,
    useWhatIfChargeCodesForNewBilltoQuery,
    useLazyWhatIfChargeCodesForNewBilltoQuery,
    useGetAllCarrServicesQuery,
    useLazyGetAllCarrServicesQuery,
    useCreateCarrierServicesMutation,
    useGetCarrierServicesByIdQuery,
    useLazyGetCarrierServicesByIdQuery,
    useModifyCarrierServiceMutation,
    useDeleteCarrierServicesMutation,
    useGetAllowedCarrSvcAuditFnsQuery,
    useLazyGetAllowedCarrSvcAuditFnsQuery,
    useGetAllCmContractsQuery,
    useLazyGetAllCmContractsQuery,
    useCreateCmContractsMutation,
    useModifyCmContractsMutation,
    useDeleteCmContractsMutation,
    useGetAllMasterCodesQuery,
    useLazyGetAllMasterCodesQuery,
    useGetMasterCodesForElementQuery,
    useLazyGetMasterCodesForElementQuery,
    useModifyMasterCodesMutation,
    useGetMasterCodeFiltersQuery,
    useLazyGetMasterCodeFiltersQuery,
    useGetActiveCurrencyCodesQuery,
    useLazyGetActiveCurrencyCodesQuery,
    useGetAuditFailCodesQuery,
    useLazyGetAuditFailCodesQuery,
    useGetCustomerContactsByIdQuery,
    useLazyGetCustomerContactsByIdQuery,
    useCreateCustomerContactsMutation,
    useModifyCustomerContactsMutation,
    useDeleteCustomerContactsMutation,
    useGetAllCurrenciesQuery,
    useLazyGetAllCurrenciesQuery,
    useGetRefDefsQuery,
    useLazyGetRefDefsQuery,
    useCreateRefDefMutation,
    useModifyRefDefMutation,
    useDeleteRefDefMutation,
    useCreateReceivableBatchesForCustomersMutation,
    useCreateReceivableBatchesFromInvoicesMutation,
    useGetListQuery,
    useLazyGetListQuery,
    useUpsertMutation,
    useGetCustPayByBillToIdByIdQuery,
    useLazyGetCustPayByBillToIdByIdQuery,
    useGetCustPaySetupByIdQuery,
    useLazyGetCustPaySetupByIdQuery,
    useCreateCustPaySetupMutation,
    useModifyCustPaySetupMutation,
    useDeleteCustPaySetupMutation,
    useGetShipmentCountByStatusQuery,
    useLazyGetShipmentCountByStatusQuery,
    useGetAgedInvoiceSummaryQuery,
    useLazyGetAgedInvoiceSummaryQuery,
    useGetDataEntryAdminInfoByCustomerQuery,
    useLazyGetDataEntryAdminInfoByCustomerQuery,
    useCreateDataEntryAdminInfoMutation,
    useModifyDataEntryAdminInfoMutation,
    useDeleteDataEntryAdminInfoMutation,
    useInvoiceResearchExportMutation,
    useGetDataExportsQuery,
    useLazyGetDataExportsQuery,
    useDeleteExportMutation,
    useSendMailWithOutAttachmentsMutation,
    useBulkCodingMutation,
    useGetGlCodeForInvoiceMutation,
    usePostHopkinsDepartmentMutation,
    useGetHealthCheckQuery,
    useLazyGetHealthCheckQuery,
    useGetQuery,
    useLazyGetQuery,
    useGetImageQuery,
    useLazyGetImageQuery,
    useDeleteImageMutation,
    useDisconnectImageMutation,
    useGetDisconnectedImagesQuery,
    useLazyGetDisconnectedImagesQuery,
    useUploadDisconnectedImageMutation,
    useReleaseInvoiceMutation,
    useGetBasicInvInfoMutation,
    useGetDetailedChargesQuery,
    useLazyGetDetailedChargesQuery,
    useGetReferencesQuery,
    useLazyGetReferencesQuery,
    useUpdateReferencesMutation,
    useGetImagesQuery,
    useLazyGetImagesQuery,
    useUpdateCommentMutation,
    useGetInvoiceResearchPopulationDataQuery,
    useLazyGetInvoiceResearchPopulationDataQuery,
    useSearchInvoicesMutation,
    useReactDataTableServerSideProcessingMutation,
    useGetMakeRealWorkaroundInvoicesQuery,
    useLazyGetMakeRealWorkaroundInvoicesQuery,
    usePostMakeRealWorkaroundInvoicesMutation,
    useGetStatusesForExceptionsQuery,
    useLazyGetStatusesForExceptionsQuery,
    useGetExceptionsForGridQuery,
    useLazyGetExceptionsForGridQuery,
    useSaveCurrentRemarksMutation,
    useAcceptAsEnteredMutation,
    useAcceptAsAuditedMutation,
    useAcceptAsAdjustedMutation,
    useRefuseInvoiceMutation,
    useExceptionManagerDeleteMutation,
    useGetAvailableAuditFailStatusesQuery,
    useLazyGetAvailableAuditFailStatusesQuery,
    useGetCarrierChargeCodeSourcesQuery,
    useLazyGetCarrierChargeCodeSourcesQuery,
    useGetCustomerDataEntryCodesForUserQuery,
    useLazyGetCustomerDataEntryCodesForUserQuery,
    useGetCustomerDataEntryCodesQuery,
    useLazyGetCustomerDataEntryCodesQuery,
    useGetIa360ReportingLinkQuery,
    useLazyGetIa360ReportingLinkQuery,
    useGetInvoiceStatusCodesQuery,
    useLazyGetInvoiceStatusCodesQuery,
    useGetEntryMethodsQuery,
    useLazyGetEntryMethodsQuery,
    useGetActivityCodesQuery,
    useLazyGetActivityCodesQuery,
    useGetAscRefCodesQuery,
    useLazyGetAscRefCodesQuery,
    useGetAscChargeCodesQuery,
    useLazyGetAscChargeCodesQuery,
    useGetTransportModesQuery,
    useLazyGetTransportModesQuery,
    useGetInvoiceTypeListQuery,
    useLazyGetInvoiceTypeListQuery,
    useGetCarrierPayableExceptionsByIdQuery,
    useLazyGetCarrierPayableExceptionsByIdQuery,
    useCreateCarrierPayExceptionMutation,
    useModifyCarrierPayExceptionMutation,
    useDeleteCarrierPayExceptionMutation,
    useGetAllPayDayStartsQuery,
    useLazyGetAllPayDayStartsQuery,
    useGetPermittedValsByCustomerQuery,
    useLazyGetPermittedValsByCustomerQuery,
    useCreatePermittedValueMutation,
    useModifyPermittedValueMutation,
    useDeletePermittedValueMutation,
    useGetPostalCodesQuery,
    useLazyGetPostalCodesQuery,
    useCreatePostalCodeMutation,
    useModifyPostalCodeMutation,
    useDeletePostalCodeMutation,
    useGetStatesQuery,
    useLazyGetStatesQuery,
    useCreateStatesMutation,
    useModifyStatesMutation,
    useDeleteStatesMutation,
    useGetTimecardForUserIdQuery,
    useLazyGetTimecardForUserIdQuery,
    useAddTimeCardMutation,
    useDeleteTimeCardMutation,
    useGetUserBillToInfoByCustomerQuery,
    useLazyGetUserBillToInfoByCustomerQuery,
    useCreateUserBillToInfoMutation,
    useDeleteUserBillToInfoMutation,
    useGetMyConfigQuery,
    useLazyGetMyConfigQuery,
    useSaveMyConfigMutation,
    useGetUserConfigurationQuery,
    useLazyGetUserConfigurationQuery,
    useSaveUserConfigMutation,
    useGetAllUsersQuery,
    useLazyGetAllUsersQuery,
    useGetTimeCardUsersQuery,
    useLazyGetTimeCardUsersQuery,
    useGetUserSessionsForUserQuery,
    useLazyGetUserSessionsForUserQuery,
    useGetMyUserSessionsQuery,
    useLazyGetMyUserSessionsQuery,
    useGetCarrInvStatsForUserQuery,
    useLazyGetCarrInvStatsForUserQuery,
    useGetMyCarrInvStatsQuery,
    useLazyGetMyCarrInvStatsQuery,
} = injectedRtkApi;
